import React, { useState, useMemo, useEffect, useCallback } from 'react'
import moment from 'moment'
import { connectedApiService as api } from '../../../../../index'
import { useParams } from 'react-router'
import { useGetTableData } from '../../../../../hooks'
import {
  getFormattedPrice,
  getFormattedTripInfo,
  getLabelFromValue,
  numberWithCommas,
  formatSentenceCase,
  isMobile,
  getPartnerOriginLink,
  getMeetAssistMeesage,
  formatPassengerAge,
  getMeetAssistLegHoursIncluded,
} from '../../../../../helpers'
import { connect } from 'react-redux'
import { withRouter, useLocation, Link } from 'react-router-dom'
import {
  resolveDispatchFields,
  resolvePrimaryVipDispatch,
  resolveServiceStatus,
  resolveFlightInfo,
  resolveTravelDocuments,
  resolveCancellationPolicy,
  isStandaloneVip,
  resolveVipPassengers,
} from '../../../../../helpers/resolveVipFields'
import {
  acceptOfferVIP,
  declineOffer,
  updateGreetActions,
  generatePdfBoard,
  vipBookingChangesPartner,
  updateChangesStatusPartner,
} from '../../../../../actions/partners'
import {
  cancelDispatchBooking,
  cancelDispatchBookingMobile,
  getBookingTimeZone,
} from '../../../../../actions/booking'
import {
  defaultBookingServicePartner,
  defaultCurrencies,
  partnerHostLive,
  partnerHostStaging,
} from '../../../../../constants'
import { SmallUp, SmallDown } from 'components/Responsive/breakpoints'
import ConfirmationModal from '../../../../../components/confirmationModal'
import LoadingSpinner from '../../../../../components/LoadingSpinner'
import { Col, Row, Button, Badge, Modal } from 'react-bootstrap'
import DefaultDriverDesktopLayout from 'components/layout/DefaultDriverDesktopLayout'
import invoke from 'react-native-webview-invoke/browser'
import _ from 'lodash'
import Support from '../User/Support'
import PartnerAcceptedModal from '../../../../../components/PartnerAcceptedModal'
import {
  getContinent,
  getPrivatePartnerFileURL,
  logger,
} from '../../../../../actions'
import { UAParser } from 'ua-parser-js'
import DeclineOfferModal from 'components/DeclineOfferModal'
import { unitSystems } from 'constants/CountryList'
import DispatchPartnerModal from 'components/DriversApp/DispatchPartnerModal'
import { Formik } from 'formik'
import DispatchCancelModal from 'pages/App/SystemPages/Bookings/BookingDetails/DispatchCancelModal'
import DispatchPartnerModalMobile from 'components/DriversApp/DispatchPartnerModalMobile'
import AdditionalChargesModal from 'components/DriversApp/AdditionalChargesModal'
import PartnerPricingDetails from 'components/DriversApp/PartnerPricingDetails'
import TooltipOnHover from 'components/TooltipOnHover'
import CompleteTripModal from 'components/CompleteTripModal'
import * as MTZ from 'moment-timezone'
import { displayTerminal } from 'helpers/terminalDisplay'

const Host = window.location.hostname
const dateFormatDetailed = 'ddd, Do MMM YYYY'
const timeFormat = 'LT'
const newTimeFormat = 'HH:mm'
const apiHost = process.env.REACT_APP_APIHOST
const isMobileBrowser = isMobile()

const formattedString = suppliers => {
  return suppliers.map((item, index, array) => {
    if (index === array.length - 1) {
      return item.name + '.'
    } else {
      return item.name + ', '
    }
  })
}

//Booking counter compoenent to prevent whole component from re-rendering over and over again
const BookingCountdown = React.memo(({ geoData, listExists }) => {
  const [timer, setTimer] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  })

  useEffect(() => {
    if (!listExists || !geoData) return

    let count = 0

    const updateTimer = () => {
      let offSet = geoData.location.rawOffset + geoData.location.dstOffset
      let timeToEvent = geoData.eventTimeStamp * 1000
      let currentTime = new Date(
        (Math.floor(new Date(geoData.localTimeStamp * 1000) / 1000) + offSet) *
          1000
      )
      let diffTime = timeToEvent - currentTime - count * 1000
      let duration = moment.duration(diffTime, 'milliseconds')

      let months = duration.months()
      let days = duration.days()
      let hours = duration.hours()
      let minutes = duration.minutes()
      let seconds = duration.seconds()

      if (months > 0) days += months * 30

      if (days >= 0 && hours >= 0 && minutes >= 0 && seconds >= 0) {
        setTimer({ days, hours, minutes, seconds })
      }

      count += 1
    }

    updateTimer()
    const interval = setInterval(updateTimer, 1000)
    return () => clearInterval(interval)
  }, [geoData, listExists])

  return (
    <>
      {!!timer.days && (
        <>
          <span>{timer.days}</span>
          <span>d</span>
        </>
      )}
      {!!timer.hours && (
        <>
          <span>{timer.hours}</span>
          <span>h</span>
        </>
      )}
      <span>{timer.minutes}</span>
      <span>m</span>
      <span>{timer.seconds}</span>
      <span>s</span>
    </>
  )
})

const BookingTimerAfterDropOff = ({
  list,
  updateServiceComplete,
  setShowCompleteBookingModal,
  isArrival,
}) => {
  const [bookingTimer, setBookingTimer] = useState(null)
  useEffect(() => {
    const update = updateServiceComplete

    if (!update) {
      return
    }

    let calculateRemainingTime = () => {
      const timeZoneId = list.pickUpLocation?.timeZoneId
      let localTime = timeZoneId ? moment().tz(timeZoneId) : moment.utc()
      let formatTime = localTime.format('YYYY-MM-DDTHH:mm:ss')
      let currentTime = moment().utc()

      let serviceCompleteTime = moment.utc(update.time)
      let targetTime = serviceCompleteTime.add(24, 'hours')

      let duration = moment.duration(targetTime.diff(currentTime))
      if (duration.asMilliseconds() <= 0) {
        return { hours: 0, minutes: 0, seconds: 0 }
      }

      return {
        days: Math.floor(duration.asDays()),
        hours: duration.hours(),
        minutes: duration.minutes(),
        seconds: duration.seconds(),
      }
    }

    const interval = setInterval(() => {
      const remainingTime = calculateRemainingTime()

      if (
        remainingTime.hours <= 0 &&
        remainingTime.minutes <= 0 &&
        remainingTime.seconds <= 0
      ) {
        clearInterval(interval)
      } else {
        setBookingTimer(remainingTime)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [updateServiceComplete, list])

  if (
    (isArrival &&
      (list.vipArrivalDispatchStatus === 'completed' ||
        list.vipArrivalDispatchStatus === 'incomplete')) ||
    (!isArrival &&
      (list.vipDepartureDispatchStatus === 'completed' ||
        list.vipDepartureDispatchStatus === 'incomplete'))
  ) {
    return null
  }

  if (!setBookingTimer) {
    return null
  }

  if (!bookingTimer) {
    return <></>
  }

  //countdown display (reusable for both variants)
  const CountdownDisplay = () => (
    <div
      className='partner-countdown text-red'
      style={!isMobileBrowser ? { color: '#d0021b', alignSelf: 'center' } : {}}
    >
      {!!bookingTimer.days && (
        <>
          <span>{bookingTimer.days}</span>
          <span>d</span>
        </>
      )}
      {!!bookingTimer.hours && (
        <>
          <span>{bookingTimer.hours}</span>
          <span>h</span>
        </>
      )}
      <span>{bookingTimer.minutes}</span>
      <span>m</span>
      <span>{bookingTimer.seconds}</span>
      <span>s</span>
    </div>
  )

  //desktop layout

  if (!isMobileBrowser) {
    return (
      <div className='partner-banner-desktop mt-4' style={{ gap: '30px' }}>
        <div className='d-flex' style={{ flex: 8 }}>
          <div className='warning-imageContainer'>
            <img src='/images/icons/icon-warning.png' alt='' />
          </div>
          <div className='partnerContainer'>
            <p>Action required</p>
            <span style={{ marginTop: '3px', maxWidth: '700px' }}>
              Complete the service and report any additional charges, such as
              additional passenger or luggage or service extension, within 24
              hours of service completion. If no report is submitted, the
              booking will be completed with no extra charges.
            </span>
          </div>
        </div>
        <CountdownDisplay />
        <Button
          className='select-chauffeur'
          style={{
            marginRight: '0em',
            flex: 2,
            width: '215px',
            maxWidth: '215px',
          }}
          variant='brown'
          onClick={() => {
            setShowCompleteBookingModal(true)
          }}
        >
          Complete booking
        </Button>
      </div>
    )
  }

  //mobile layout
  return (
    <div className='partner-banner mt-4' style={{ gap: '30px' }}>
      <div className='partnerContainerComplete'>
        <div className='partnerContainerHead'>
          <div className='d-flex'>
            <div className='imageContainer' style={{ marginLeft: '0' }}>
              <img src='/images/icons/icon-warning.png' alt='' />
            </div>
            <p className='text-red' style={{ marginLeft: '5px' }}>
              Action required
            </p>
          </div>
          <CountdownDisplay />
        </div>
        <span style={{ marginTop: '3px' }}>
          Complete the service and report any additional charges, such as
          additional passenger or luggage or service extension, within 24 hours
          of service completion. If no report is submitted, the booking will be
          completed with no extra charges.
        </span>
      </div>
    </div>
  )
}

const renderBookingChanges = bookingChanges => {
  const formatMessage = info => {
    let newText = info.message

    if (info.type.includes('passengerInfoChange')) {
      const lines = newText
        .split('<br>')
        .map(line => line.trim())
        .filter(Boolean)

      const [header, ...details] = lines
      newText = `${header} ${details.join(', ')}`
    } else {
      const lines = newText
        .split('<br>')
        .map(line => line.trim())
        .filter(Boolean)

      if (lines.length > 1) {
        newText = `${lines[0]} ${lines.slice(1).join(', ')}`
      } else {
        newText = lines[0] || ''
      }
    }

    return `— ${newText.trim()}`
  }

  return bookingChanges
    .filter(
      item =>
        item.status_admin === 'sent' &&
        (item.status_partner === 'opened' ||
          item.status_partner === 'not_opened')
    )
    .map((info, index) => (
      <span key={index} className='w-100'>
        {formatMessage(info)}
      </span>
    ))
}

// Module-scope (outside the component) so the conditional logic isn't analysed by
// the legacy eslint-plugin-react-hooks, which mis-flags later hooks when it sees a
// ternary/if in the component body. Returns the leg word for the header + price label.
const resolveVipLegWord = (isTransit, isDeparture) => {
  if (isTransit) return 'Transit'
  if (isDeparture) return 'Departure'
  return 'Arrival'
}

// Module-scope (see resolveVipLegWord) — standalone VIP flight date/time by leg.
const resolveStandaloneFlightDateTime = (
  isStandaloneVip,
  isDeparture,
  standaloneFlightInfo
) => {
  if (!isStandaloneVip) return null
  return isDeparture
    ? standaloneFlightInfo && standaloneFlightInfo.departureTime
    : standaloneFlightInfo && standaloneFlightInfo.arrivalTime
}

// Module-scope: builds the "2 adults, 1 child" passenger summary string.
// Hoisted out of the component body because the legacy eslint-plugin-react-hooks
// mis-parses the bare body-level `if` statements and flags every later hook as
// conditionally called, breaking the build (see eslint-hooks-trap).
const buildStandalonePassengerSummary = passengers => {
  const list = Array.isArray(passengers) ? passengers : []
  const adults = list.filter(
    p => (p.passengerType || 'adult').toLowerCase() === 'adult'
  ).length
  const children = list.filter(
    p => (p.passengerType || '').toLowerCase() === 'child'
  ).length
  const infants = list.filter(
    p => (p.passengerType || '').toLowerCase() === 'infant'
  ).length
  const parts = []
  if (adults > 0) parts.push(`${adults} adult${adults > 1 ? 's' : ''}`)
  if (children > 0) parts.push(`${children} child${children > 1 ? 'ren' : ''}`)
  if (infants > 0) parts.push(`${infants} infant${infants > 1 ? 's' : ''}`)
  return parts.join(', ')
}

// Module-scope: resolves the standalone-VIP service-feature lines for the booking's
// leg. Hoisted out of the component because the nested isTransit/isDeparture ternary
// (previously inline) tripped the legacy eslint-plugin-react-hooks and flagged every
// later hook as conditionally called, breaking the build (see eslint-hooks-trap).
const resolveStandaloneServiceFeatures = (
  isStandaloneVip,
  list,
  isTransit,
  isDeparture
) => {
  if (!isStandaloneVip || !list || !list.vipRate) return []
  let message
  if (isTransit) {
    message =
      list.vipRate.messageChauffeuredTransit ||
      list.vipRate.messageChauffeuredArrival ||
      ''
  } else if (isDeparture) {
    message = list.vipRate.messageChauffeuredDeparture || ''
  } else {
    message = list.vipRate.messageChauffeuredArrival || ''
  }
  return getMeetAssistMeesage(message).filter(line => line.trim())
}

// Module-scope: resolves service-feature lines for add-on VIP from the
// meetAndAssist leg object (arrivalInfo / departureInfo). Mirrors the logic
// of resolveStandaloneServiceFeatures but reads from the nested leg instead
// of list.vipRate.
const resolveAddonServiceFeatures = (isStandaloneVip, list, isDeparture) => {
  if (isStandaloneVip || !list || !list.meetAndAssist) return []
  const leg = isDeparture
    ? list.meetAndAssist.departure
    : list.meetAndAssist.arrival
  if (!leg) return []
  const message = isDeparture
    ? leg.messageChauffeuredDeparture || leg.messageChauffeuredArrival || ''
    : leg.messageChauffeuredArrival || ''
  return getMeetAssistMeesage(message).filter(line => line.trim())
}

// Module-scope: resolves passenger list for add-on VIP — mirrors standalone via
// resolveVipPassengers (prefers Bookings.vipPassengers, falls back to meetAndAssist.passengers).
const resolveAddonVipPassengers = (isStandaloneVip, list) => {
  if (isStandaloneVip || !list) return []
  return resolveVipPassengers(list)
}

// Transfer partners often assign via driverTemp before driver is promoted.
// Match BookingDetails.jsx so VIP M&G partners see chauffeur details too.
const resolveAssignedChauffeur = list => {
  if (!list) return null
  const chauffeur = list.driver || list.driverTemp
  return chauffeur && chauffeur.fullName ? chauffeur : null
}

const resolveAssignedChauffeurVehicle = list => {
  if (!list) return ''
  if (list.partnerVehicle) return list.partnerVehicle
  if (list.globalVehicle) {
    return `${list.globalVehicle.brandName || ''} ${list.globalVehicle
      .modelName || ''}`.trim()
  }
  return list.vehicleName || ''
}

const getVipPassengerCardHeader = (passenger, idx) => {
  const pType = (passenger.passengerType || 'adult').toLowerCase()
  const typeLabel =
    pType === 'child' ? 'Child' : pType === 'infant' ? 'Infant' : 'Adult'
  const globalNumber = idx + 1
  return `Passenger ${globalNumber} (${typeLabel})`
}

const resolveVipPassengerDisplayName = passenger => {
  if (!passenger) return ''
  const title =
    typeof passenger.title === 'object'
      ? passenger.title?.label || passenger.title?.value || ''
      : passenger.title || ''
  const titlePrefix = title ? `${title} ` : ''
  if (passenger.fullName) return `${titlePrefix}${passenger.fullName}`.trim()
  const firstName = passenger.firstName || ''
  const lastName = passenger.lastName || ''
  return `${titlePrefix}${firstName} ${lastName}`.trim()
}

// Partner passenger cards — shared by standalone + add-on VIP (accepted state).
const renderVipPartnerPassengerCards = (
  passengers,
  list,
  downloadVipFile,
  { showName = true, showPhone = true, showDocuments = true } = {}
) => {
  if (!passengers?.length) return null

  return passengers.map((passenger, idx) => {
    const pType = (passenger.passengerType || 'adult').toLowerCase()
    const isLead =
      pType === 'adult' &&
      passenger.phone &&
      !passengers.slice(0, idx).some(function(p) {
        return (p.passengerType || 'adult').toLowerCase() === 'adult' && p.phone
      })
    const displayName = resolveVipPassengerDisplayName(passenger)
    const hasPassport =
      passenger.passport && typeof passenger.passport === 'string'
    const hasAirlineTicket =
      passenger.airlineTicket && typeof passenger.airlineTicket === 'string'
    const leadPhone =
      showPhone &&
      isLead &&
      (passenger.phone ||
        list?.passengerInfo?.phone ||
        list?.driversInfo?.[0]?.phone)

    return (
      <div key={idx} className='driver-service-card'>
        <div
          className='driver-service-card-header'
          style={{ fontSize: '15px' }}
        >
          {getVipPassengerCardHeader(passenger, idx)}
        </div>
        <div className='driver-service-card-body'>
          {showName && displayName && (
            <div className='driver-service-card-item'>
              <span>Guest name</span>
              <span>{displayName}</span>
            </div>
          )}
          {leadPhone && (
            <div className='driver-service-card-item'>
              <span>Phone number</span>
              <span>{leadPhone}</span>
            </div>
          )}
          {passenger.nationality && (
            <div className='driver-service-card-item'>
              <span>Nationality</span>
              <span>{passenger.nationality}</span>
            </div>
          )}
          {formatPassengerAge(passenger.age, passenger.passengerType) !=
            null && (
            <div className='driver-service-card-item'>
              <span>Age</span>
              <span>
                {formatPassengerAge(passenger.age, passenger.passengerType)}
              </span>
            </div>
          )}
          {(typeof passenger.travelClass === 'object'
            ? passenger.travelClass?.label || passenger.travelClass?.value
            : passenger.travelClass) && (
            <div className='driver-service-card-item'>
              <span>Travel class</span>
              <span>
                {typeof passenger.travelClass === 'object'
                  ? passenger.travelClass?.label || passenger.travelClass?.value
                  : passenger.travelClass}
              </span>
            </div>
          )}
          {showDocuments && (hasPassport || hasAirlineTicket) && (
            <div className='name-board'>
              <Button
                className='partner-btn-desktop-secondary select-vehicle'
                variant='brown'
                onClick={() =>
                  Promise.all([
                    hasPassport ? downloadVipFile(passenger.passport) : null,
                    hasAirlineTicket
                      ? downloadVipFile(passenger.airlineTicket)
                      : null,
                  ])
                }
              >
                Download documents
              </Button>
            </div>
          )}
        </div>
      </div>
    )
  })
}

// Module-scope: resolves hours-included display for add-on VIP Terms card.
// Hoisted out of the component because nested ternaries before hooks trip the
// legacy eslint-plugin-react-hooks and flag every later hook as conditional.
const resolveAddonVipHoursIncluded = (isStandaloneVip, list, isArrival) => {
  if (isStandaloneVip || !list?.meetAndAssist) {
    return { hoursIncluded: 0, show: false }
  }

  const leg = isArrival
    ? list.meetAndAssist.arrival
    : list.meetAndAssist.departure
  const legHours = getMeetAssistLegHoursIncluded(leg)
  const vipRateHours =
    list?.vipRate?.hoursIncluded || list?.vipRate?.hours_included
  const parsedVipRateHours = vipRateHours ? parseFloat(vipRateHours) : 0
  const hoursIncluded = legHours > 0 ? legHours : parsedVipRateHours

  return {
    hoursIncluded,
    show: hoursIncluded > 0,
  }
}

// Renders the add-on VIP "Hours included" Terms row. Kept at module scope so the
// component body stays free of extra destructuring before hooks.
const renderAddonHoursIncludedRow = (list, isArrival) => {
  const { show, hoursIncluded } = resolveAddonVipHoursIncluded(
    false,
    list,
    isArrival
  )
  if (!show) return null
  return (
    <div className='driver-service-card-item'>
      <span>Hours included</span>
      <span>{hoursIncluded} hours</span>
    </div>
  )
}

const BookingDetailsVIP = ({
  history,
  acceptOfferVIP,
  declineOffer,
  getBookingTimeZone,
  updateGreetActions,
  generatePdfBoard,
  getPrivatePartnerFileURL,
  vipBookingChangesPartner,
  updateChangesStatusPartner,
  getContinent,
  cancelDispatchBooking,
  cancelDispatchBookingMobile,
  isLocalSupplier,
  companyId,
}) => {
  const { bookingId, token, vip } = useParams()

  let location = useLocation()
  let currentLocation = location.pathname
  let partnerLink = Host === partnerHostLive || Host === partnerHostStaging
  // URL-derived leg — used only to seed the booking fetch below (before `list`
  // is available).
  const _urlTransit = location.pathname.includes('/transit/')
  const _urlDeparture = location.pathname.includes('/departure/')
  const _urlArrival = !_urlDeparture && !_urlTransit

  const {
    data: { list },
    reloadList,
    isLoading,
  } = useGetTableData(
    `external/vipPartnerBooking/${bookingId}/${token}`,
    _urlArrival ? { isArrival: true } : {}
  )

  // STANDALONE VIP: the service leg is authoritative on the booking
  // (vipServiceType), so derive the DISPLAY leg from it — an accepted transit
  // booking then always shows "Transit" + the correct service details,
  // regardless of which URL leg it was opened with. Legacy add-on VIP and every
  // other booking keep the URL-based leg unchanged.
  const _svLeg =
    list && list.isStandaloneVip === true ? list.vipServiceType : null
  const isTransit = _svLeg ? _svLeg === 'transit' : _urlTransit
  const isDeparture = _svLeg ? _svLeg === 'departure' : _urlDeparture
  const isArrival = _svLeg ? _svLeg === 'arrival' : _urlArrival

  // Transit-aware leg label for the header card + price rows. Resolved via a
  // module-scope helper (plain function call — NOT an inline ternary or if/else)
  // because the legacy eslint-plugin-react-hooks mis-parses conditionals in the
  // component body and flags every later hook as conditionally called. Legacy
  // add-on VIP never sets isTransit, so its Arrival/Departure label is unchanged.
  const vipLegWord = resolveVipLegWord(isTransit, isDeparture)
  const vipLegFull = `VIP Meet & Greet, ${vipLegWord}`

  // resolveFlightInfo is called unconditionally (safe for legacy VIP; guarded by isStandaloneVip in JSX).
  // For transit URL we use the arrival leg as the primary `standaloneFlightInfo`
  // (drives the countdown). The departure leg is exposed separately as
  // `transitDepartureFlightInfo` and only rendered for standalone VIP transit.
  const standaloneFlightInfo = resolveFlightInfo(
    list,
    isDeparture ? 'departure' : null
  )
  const isStandaloneVip = list?.isStandaloneVip
  // Standalone VIP has no chauffeur/vehicle — hide the dispatched driver card +
  // chauffeur placeholder. Hoisted out of JSX: the legacy eslint-plugin-react-hooks
  // mis-parses boolean ops in this nested ternary and flags all hooks as conditional.
  const showDispatchedDriverCard =
    !isStandaloneVip && !!list && list.vipDispatchStatus === 'dispatched'

  // Add-on VIP chauffeur card: prefer driver, fall back to driverTemp.
  const assignedChauffeur = resolveAssignedChauffeur(list)
  const assignedChauffeurVehicle = resolveAssignedChauffeurVehicle(list)

  // ─── Standalone VIP: passengers, summary, service features, accepted state ───
  const standalonePassengers = isStandaloneVip ? resolveVipPassengers(list) : []
  const standalonePassengerSummary = buildStandalonePassengerSummary(
    standalonePassengers
  )
  const standaloneServiceFeatures = resolveStandaloneServiceFeatures(
    isStandaloneVip,
    list,
    isTransit,
    isDeparture
  )
  const isStandaloneAccepted =
    isStandaloneVip && list && list.dispatchStatus === 'accepted'

  // ─── Add-on VIP: service features + pre-accept passengers ────────────────
  const addonServiceFeatures = resolveAddonServiceFeatures(
    isStandaloneVip,
    list,
    isDeparture
  )
  const addonPassengers = resolveAddonVipPassengers(isStandaloneVip, list)
  // Formatted passenger summary for the Service card (mirrors standalonePassengerSummary).
  // Falls back to raw vehicle.passengers count if the passengers array isn't available yet.
  const addonPassengerSummary =
    addonPassengers.length > 0
      ? buildStandalonePassengerSummary(addonPassengers)
      : null
  // Supplier considered accepted for the partner "confirm change(s)" banners.
  // Standalone VIP relies on the root dispatchStatus; legacy add-on VIP keeps
  // the supplierInfo.status check. Hoisted out of the JSX because the legacy
  // eslint-plugin-react-hooks version mis-parses || groups inside ternary tests.
  const changesSupplierAccepted = !!(
    list &&
    list.supplierInfo &&
    (list.supplierInfo.status === 'accepted' || isStandaloneAccepted)
  )

  // Mobile "Get PDF name-board" CTA visibility. Hoisted out of the JSX (the nested
  // ||/&& groups trip the legacy eslint-plugin-react-hooks). Legacy: supplierInfo
  // accepted + commercial flight/train/cruise. Standalone VIP accepts via
  // dispatchStatus (changesSupplierAccepted), so allow it there with a flight (QA 22).
  const mobileNameboardVisible = !!(
    (list &&
      list.supplierInfo &&
      list.supplierInfo.status === 'accepted' &&
      ((list.airportPickUpInfo &&
        list.airportPickUpInfo.flightType === 'commercial') ||
        list.trainPickUpInfo ||
        (list.shipPickUpInfo && list.shipPickUpInfo.shipType === 'cruise'))) ||
    (isStandaloneVip &&
      changesSupplierAccepted &&
      list &&
      (list.arrivalFlightInfo || list.departureFlightInfo))
  )

  // Standalone VIP transit only — second leg (departure flight at the same airport).
  const transitDepartureFlightInfo =
    isStandaloneVip && isTransit ? list && list.departureFlightInfo : null

  // Standalone VIP transit only — departure flight number for the mobile card's
  // 2nd flight row (QA 29). Hoisted out of JSX to avoid the legacy
  // eslint-plugin-react-hooks mis-parsing the ||/&& group.
  const transitDepartureFlightNumber =
    isStandaloneVip && isTransit && list
      ? (list.airportDropOffInfo && list.airportDropOffInfo.flightNumber) ||
        (list.departureFlightInfo && list.departureFlightInfo.flightNumber) ||
        ''
      : ''

  // Hours included is only meaningful when the rate has a per-hour price.
  // Standalone VIP rates with sellingRatePerHour = 0 must hide the row (QA 29).
  const showHoursIncluded =
    !isStandaloneVip ||
    !!(list && list.vipRate && list.vipRate.sellingRatePerHour)

  // Standalone VIP flight-row icon: a landing/arrival glyph for the arrival leg
  // (arrival service + transit's first flight, both driven by airportPickUpInfo)
  // and a take-off glyph for the departure leg (departure service, which only has
  // airportDropOffInfo). Transit's second flight always uses the departure glyph.
  // Non-VIP keeps the legacy airport icon. Hoisted to a body const to avoid the
  // legacy eslint-plugin-react-hooks trap with nested JSX ternaries.
  const standaloneFirstFlightIcon =
    list && list.airportPickUpInfo
      ? '/images/icons/icon-flight-vipmg-arrival.svg'
      : '/images/icons/icon-flight-vipmg-departure.svg'

  // Arrival bookings use arrivalTime; departure bookings use departureTime.
  // Transit bookings use arrivalTime as the primary (the moment the chauffeur meets the passenger).
  // Resolved via a module-scope helper (plain call) — the previous inline nested
  // ternary tripped the legacy eslint-plugin-react-hooks and flagged every later
  // hook as conditionally called, breaking the build.
  const standaloneFlightDateTime = resolveStandaloneFlightDateTime(
    isStandaloneVip,
    isDeparture,
    standaloneFlightInfo
  )

  const listExists = useMemo(() => {
    return Array.isArray(list) ? list.length > 0 : !!list
  }, [list])
  const { data } = useGetTableData(`external/partner/${token}`)
  const {
    data: { list: tokenUser },
  } = useGetTableData(`external/partnerToken/${token}`)

  const [selectedTab, setSelectedTab] = useState(() => {
    return currentLocation && currentLocation.includes('trip') ? 1 : 0
  })
  const [driverExists, setDriverExists] = useState(false)
  const [updateOnSite, setUpdateOnSite] = useState(null)
  const [updateContactMade, setUpdateContactMade] = useState(null)
  const [updateServiceComplete, setUpdateServiceComplete] = useState(null)

  const [bookingTimeLeft, setBookingTimeLeft] = useState(null)
  const [canSeeUpdateButton, setCanSeeUpdateButton] = useState(null)
  const [updatePassengerDroppedOff, setUpdatePassengerDroppedOff] = useState(
    null
  )
  const [updateDayCompleted, setUpdateDayCompleted] = useState(null)
  const [proSteps, setProSteps] = useState([])
  const [step, setStep] = useState(0)
  const [isSubmitting, setSubmitting] = useState(false)
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)
  const [
    showDeclineConfirmationModal,
    setShowDeclineConfirmationModal,
  ] = useState(false)
  const [
    showDeclineChangesConfirmationModal,
    setShowDeclineChangesConfirmationModal,
  ] = useState(false)
  const [displayAlertText, setDisplayAlertText] = useState('')
  const [displayAlertTitle, setDisplayAlertTitle] = useState('')
  const [bookingInTwoHours, setBookingInTwoHours] = useState(false)
  const [details, setDetails] = useState(null)
  const [displaySupport, setDisplaySupport] = useState(false)
  const [geoData, setGeoData] = useState(null)
  const [currentDay, setCurrentDay] = useState(1)
  const [bookingTimer, setBookingTimer] = useState(null)
  const [bookingTimerAfter, setBookingTimerAfter] = useState(null)
  const [showAcceptedModal, setShowAcceptedModal] = useState(false)
  const [showDeclinedModal, setShowDeclinedModal] = useState(false)
  const [showAccptedChangesModal, setShowAccptedChangesModal] = useState(false)
  const [showDeclinedChangesModal, setShowDeclinedChangesModal] = useState(
    false
  )
  const [showCompletedModal, setShowCompletedModal] = useState(false)
  const [showCompleteBookingModal, setShowCompleteBookingModal] = useState(
    false
  )
  const [showPdf, setShowPdf] = useState(false)
  const [pdfLink, setPdfLink] = useState('')
  const [bookingChanges, setBookingChanges] = useState([])
  const [thereAreNewChanges, setThereAreNewChanges] = useState(false)
  const [buttonLabels, setButtonLabels] = useState([
    'On site',
    'Contact made',
    'Service complete',
  ])
  const [actionTypes, setActionTypes] = useState([
    'on_site',
    'contact_made',
    'service_complete',
  ])
  // const [continent, setContinent] = useState(null)
  const [dayCollapsibleArray, setDayCollapsibleArray] = useState([])

  //LocalSupplier
  const [showDispatchModal, setshowDispatchModal] = useState(false)
  const [opSupplierPrice, setOpSupplierPrice] = useState(0)
  const [suppliersList, setSuppliersList] = useState([])
  const [showDispatchCancelModal, setshowDispatchCancelModal] = useState(false)
  const [showAddChargeModal, setShowAddChargeModal] = useState(false)
  const [bookingNotFound, setBookingNotFound] = useState(false)

  useEffect(() => {
    const checkTokenValidity = async () => {
      try {
        const url = `external/partnerToken/${token}`
        const { data } = await api.get(url)
        setDetails(data)
      } catch (err) {
        console.log('checkTokenValidity error', err)
        logger({ fileName: 'checkTokenValidity error', error: err })
      }
    }
    checkTokenValidity()
  }, [])

  useEffect(() => {
    if (listExists) {
      if (list.greeterTemp && list.greeterTemp.fullName) {
        let driverName = list.greeterTemp.fullName
        let names = driverName.toLowerCase().split(' ')
        for (let i = 0; i < names.length; i++) {
          names[i] = names[i].charAt(0).toUpperCase() + names[i].substring(1)
        }
        list.greeterTemp.fullName = names.join(' ')
        list.greeter = list.greeterTemp
      }
      if (list.greeter && list.greeter.fullName) {
        let driverName = list.greeter.fullName
        let names = driverName.toLowerCase().split(' ')
        for (let i = 0; i < names.length; i++) {
          names[i] = names[i].charAt(0).toUpperCase() + names[i].substring(1)
        }
        list.greeter.fullName = names.join(' ')
      }
      if (!list.chauffeurOfBooking && !list.partnerOfBooking) {
        if (document.referrer === '') {
          history.push(
            `${partnerLink ? '/' : '/partner/'}driver/app/${token}/planned`
          )
        } else {
          setBookingNotFound(true)
          // window.history.back()
        }
      }
    } else if (!isLoading) {
      setBookingNotFound(true)
    }
  }, [list])

  // useEffect(() => {
  //   try {
  //     async function fetchContinent() {
  //       const data = unitSystems.find(obj => {
  //         return list.pickUpLocation.country === obj.country
  //       })
  //       setContinent(data)
  //       return data
  //     }
  //     if (listExists && list.pickUpLocation && list.pickUpLocation.country) {
  //       const data = fetchContinent()
  //       setContinent(data)
  //     }
  //   } catch (err) {
  //     console.log(err)
  //   }
  // }, [list, getContinent])

  useEffect(() => {
    if (list) {
      setCanSeeUpdateButton(true)
      // setCanSeeUpdateButton(
      //   list.chauffeurOfBooking || (!list.chauffeurOfBooking && step !== 0)
      // )
    }
  }, [list])
  const changeTab = tab => {
    setSelectedTab(tab)
  }

  const onGetFile = async fileId => {
    try {
      const { url } = await getPrivatePartnerFileURL(fileId)
      if (url) {
        setSubmitting(false)
        setPdfLink(url)
        let parser = new UAParser()
        parser.setUA(navigator.userAgent)
        const browser = parser.getBrowser().name
        const result = parser.getOS()
        const name = result.name
        window.open(url, '_blank')
      }
    } catch (error) {
      console.log('onGetFile error', error)
      logger({ fileName: 'onGetFile error', error: error })
    }
  }

  // passport / airlineTicket may be a GCS filename OR an inline data: URL
  // (when the booking still holds the raw upload). Never put data: URLs in the
  // API path — they break HTTP/2 and fail the request.
  // Large data: URLs also blank out if used with window.open; use a blob URL.
  const openVipPassengerFile = async fileRef => {
    if (!fileRef || typeof fileRef !== 'string') return
    if (fileRef.startsWith('data:')) {
      try {
        const commaIdx = fileRef.indexOf(',')
        if (commaIdx === -1) return
        const header = fileRef.slice(0, commaIdx)
        const base64 = fileRef.slice(commaIdx + 1)
        const mime =
          (header.match(/data:([^;]+)/) || [])[1] || 'application/octet-stream'
        const binary = atob(base64)
        const bytes = new Uint8Array(binary.length)
        for (let i = 0; i < binary.length; i++) {
          bytes[i] = binary.charCodeAt(i)
        }
        const blobUrl = URL.createObjectURL(new Blob([bytes], { type: mime }))
        window.open(blobUrl, '_blank')
        setTimeout(() => URL.revokeObjectURL(blobUrl), 60000)
      } catch (error) {
        console.log('openVipPassengerFile dataUrl error', error)
        logger({
          fileName: 'openVipPassengerFile dataUrl error',
          error: error,
        })
      }
      return
    }
    try {
      const { data } = await api.get(
        `external/vip-passenger-file/${list._id}/${encodeURIComponent(
          fileRef
        )}?token=${token}`
      )
      if (data?.url) {
        window.open(data.url, '_blank')
      }
    } catch (error) {
      console.log('openVipPassengerFile error', error)
      logger({ fileName: 'openVipPassengerFile error', error: error })
    }
  }

  const onGetVipFile = openVipPassengerFile
  const downloadVipFile = openVipPassengerFile

  const onAcceptBookingVIP = async bookingId => {
    try {
      if (bookingId && supplierId) {
        await acceptOfferVIP(bookingId, supplierId, { isArrival })

        setShowAcceptedModal(true)
        setTimeout(function() {
          setShowAcceptedModal(false)
        }, 1500)
        reloadList()
      }
    } catch (error) {
      console.log('onAcceptBookingVIP error', error)
      logger({ fileName: 'onAcceptBookingVIP error', error: error })
    }
  }

  const updateStatus = async (changes, bookingId) => {
    await updateChangesStatusPartner(changes, bookingId)
  }

  useEffect(() => {
    if (listExists && list.bookingChanges && list.bookingChanges.length > 0) {
      // Support both shapes:
      //   [[card, card]]  — preferred (standalone + attachVipPartnerBookingChanges)
      //   [card, card]    — flat aggregation projection
      let changes = list.bookingChanges
      if (Array.isArray(changes[0])) {
        ;[changes] = changes
      }
      if (!Array.isArray(changes) || !changes.length) return

      // Standalone VIP has a single dispatched partner and a single change list,
      // so its cards aren't tagged by leg (vip_arrival / vip_departure). Match by
      // status only — the legacy add-on VIP flow keeps the service-leg match.
      const _isStandalone = list.isStandaloneVip
      const _matchesService = item =>
        (isArrival && item.service === 'vip_arrival') ||
        (!isArrival && item.service === 'vip_departure')

      setThereAreNewChanges(
        changes.some(
          item =>
            (item.status_partner === 'not_opened' ||
              item.status_partner === 'opened') &&
            item.status_admin === 'sent' &&
            (_isStandalone || _matchesService(item)) &&
            item.type !== 'admin_additionalCharges'
        )
      )
      setBookingChanges(
        changes.filter(
          item =>
            item.status_admin === 'sent' &&
            item.type !== 'admin_additionalCharges' &&
            (_isStandalone || _matchesService(item))
        )
      )

      const notOpenedChanges = changes.filter(
        item =>
          item.status_admin === 'sent' && item.status_partner === 'not_opened'
      )
      if (notOpenedChanges && notOpenedChanges.length > 0)
        updateStatus({ bookingChanges: notOpenedChanges }, list._id)
    }
  }, [list])

  useEffect(() => {
    if (listExists && list.days && list.days.length) {
      const arr = dayCollapsibleArray
      if (arr && arr.length === 0) {
        for (let i in list.days) {
          arr.push(parseInt(i) === 0)
        }
      }
      setDayCollapsibleArray(arr)
    }

    if (listExists && isLocalSupplier) {
      const getDate = async () => {
        const { data } = await api.get(
          `booking/${list._id}/localSupplier/dispatchBooking`
        )
        setSuppliersList(data)
      }

      if (list.vipDispatchStatus !== 'not_dispatched') {
        getDate()
      }
    }

    //Supplier Dumb Price
    if (list && list.supplierInfo) {
      let info = list.supplierInfo

      setOpSupplierPrice(
        info.outsourceRate
          ? parseFloat(info.outsourceRate.toFixed(2))
          : info.dispatchWeight
          ? parseFloat(
              info.buyingPrice - info.buyingPrice * (info.dispatchWeight / 100)
            ).toFixed(2)
          : info.buyingPrice
      )
    }
  }, [list, isLocalSupplier])

  const onAcceptBookingChanges = async (
    bookingChanges,
    bookingId,
    supplierId
  ) => {
    try {
      if (bookingId) {
        let values = {
          action: 'accept',
          bookingChanges: bookingChanges,
          supplierId: supplierId,
        }
        setThereAreNewChanges(false)
        await vipBookingChangesPartner(values, bookingId)
        setShowAccptedChangesModal(true)
        setTimeout(
          function() {
            setShowAccptedChangesModal(false)
          }.bind(this),
          1500
        )
        reloadList()
      }
    } catch (error) {
      console.log('onAcceptBookingChanges', error)
      logger({ fileName: 'onAcceptBookingChanges', error: error })
    }
  }

  const onDeclineBookingChanges = async (
    bookingChanges,
    bookingId,
    supplierId
  ) => {
    try {
      if (bookingId) {
        let values = {
          action: 'decline',
          bookingChanges: bookingChanges,
          supplierId: supplierId,
        }
        setShowDeclineChangesConfirmationModal(false)
        setThereAreNewChanges(false)
        await vipBookingChangesPartner(values, bookingId)
        setShowDeclinedChangesModal(true)
        setTimeout(
          function() {
            setShowDeclinedChangesModal(false)
            history.push(
              `${
                partnerLink ? '/' : '/partner/'
              }driver/app/${token}/new-bookings`
            )
          }.bind(this),
          1500
        )
      }
    } catch (error) {
      console.log('onDeclineBookingChanges', error)
      logger({ fileName: 'onDeclineBookingChanges', error: error })
    }
  }

  const sendSMS = async () => {
    try {
      if (list.greeter.phone) {
        const url = `external/sendSmsToDriver/${list.greeter.phone}`
        await api.get(url)
        reloadList()
      }
    } catch (error) {
      console.log('sendSMS error', error)
      logger({ fileName: 'BookingDetails sendSMS error', error: error })
    }
  }

  const redirectBookings = e => {
    try {
      e.preventDefault()
      if (displaySupport && selectedTab === null) {
        setDisplaySupport(false)
        setSelectedTab(0)
      } else {
        if (document.referrer === '') {
          history.push(
            `${partnerLink ? '/' : '/partner/'}driver/app/${token}/planned`
          )
        } else {
          setBookingNotFound(true)
          // window.history.back()
        }
      }
    } catch (error) {
      console.log('redirectBookings error', error)
      logger({ fileName: 'redirectBookings error', error: error })
    }
  }

  const checkBookingAfterADay = time => {
    if (time) {
      const hours = moment.utc(time).diff(moment(), 'hours')
      return hours > 24
    }
  }

  const assignGreeter = () => {
    try {
      if (bookingId) {
        const serviceSegment = isDeparture
          ? 'departure'
          : isTransit
          ? 'transit'
          : 'arrival'
        history.push(
          `${
            partnerLink ? '/' : '/partner/'
          }driver/app/details/${serviceSegment}/greeter/assign/${token}/${bookingId}`
        )
      }
    } catch (error) {
      console.log('assignGreeter error', error)
      logger({ fileName: 'assignGreeter error', error: error })
    }
  }

  const generatePdf = async () => {
    setSubmitting(true)
    try {
      const { data } = await generatePdfBoard(list._id)
      if (data.nameBoard) {
        if (data.nameBoard.includes('.')) {
          let platform = {
            'https://business.rolzo.com/api': 'business',
            'https://staging.rolzo.com/api': 'staging',
            'http://localhost:3000': 'staging',
            'https://demo.rolzo.com/api': 'demo',
          }

          window.open(
            `https://storage.googleapis.com/rolzo-platform/${
              platform[process.env.REACT_APP_APIHOST]
            }/bookings/nameboard/${data.nameBoard}`,
            '_blank'
          )
        } else {
          onGetFile(data.nameBoard)
        }
      }
    } finally {
      setSubmitting(false)
    }
  }

  const setNameboard = invoke.bind('openLink')

  const isWebView = () => {
    const userAgent = navigator.userAgent || ''
    const isAndroidWebView =
      /wv/.test(userAgent) ||
      (/Version\/\d+\.\d+/.test(userAgent) && !/Chrome/.test(userAgent))

    const isIOSWebView =
      !!window.webkit &&
      !!window.webkit.messageHandlers &&
      !/Safari/.test(userAgent)

    const isMobileBrowser = /Chrome|Safari|Firefox|CriOS|FxiOS/.test(userAgent)

    return (isAndroidWebView || isIOSWebView) && !isMobileBrowser
  }

  const getNameboard = async () => {
    setSubmitting(true)
    const { data } = await generatePdfBoard(list._id)
    setSubmitting(false)
    if (data.nameBoard) {
      if (isWebView()) {
        const { url } = await getPrivatePartnerFileURL(data.nameBoard)
        const callGetNameboard = await setNameboard(url)
      } else {
        if (data.nameBoard.includes('.')) {
          let platform = {
            'https://business.rolzo.com/api': 'business',
            'https://staging.rolzo.com/api': 'staging',
            'http://localhost:3000': 'staging',
            'https://demo.rolzo.com/api': 'demo',
          }

          window.open(
            `https://storage.googleapis.com/rolzo-platform/${
              platform[process.env.REACT_APP_APIHOST]
            }/bookings/nameboard/${data.nameBoard}`,
            '_blank'
          )
        } else {
          onGetFile(data.nameBoard)
        }
      }
    }
  }

  useEffect(() => {
    if (!list) {
      return
    }

    if (
      list.type === 'airport_transfer' ||
      list.type === 'departure_transfer' ||
      list.type === 'return_transfer' ||
      list.type === 'chauffeur_services' ||
      list.type === 'vip_meet_greet'
    ) {
      // const isLastDay = currentDay === list.days.length
      setProSteps([
        { id: 0, title: 'On site' },
        { id: 1, title: 'Contact made' },
        { id: 2, title: 'Service complete' },
        // ...(isLastDay ? [] : [{ id: 4, title: 'Mark day complete' }]),
      ])
      setButtonLabels([
        'On site',
        'Contact made',
        'Service complete',
        // ...(isLastDay ? [] : ['Mark day complete']),
      ])
      setActionTypes([
        'on_site',
        'contact_made',
        'service_complete',
        // ...(isLastDay ? [] : ['completed']),
      ])
    }
  }, [list, setProSteps])

  useEffect(() => {
    if (!list) {
      return
    }
    if (
      listExists &&
      list.bookingOperations &&
      list.bookingOperations.length > 0 &&
      list.bookingOperations[0].actions.length > 0
    ) {
      if (list.durationType !== 'daily' || !list.days) {
        const lastAction =
          list.bookingOperations[0].actions[
            list.bookingOperations[0].actions.length - 1
          ]
        const idx = actionTypes.findIndex(
          action => action === lastAction.status
        )
        if (idx !== -1) {
          setStep(idx + 1)
        }
      } else {
        let actions = list.bookingOperations[0].actions.filter(function(el) {
          return el.day === currentDay
        })

        if (actions.length > 0) {
          const lastAction = actions[actions.length - 1]
          const idx = actionTypes.findIndex(
            action => action === lastAction.status
          )
          if (idx !== -1) {
            setStep(idx + 1)
          }
        } else {
          let actions = list.bookingOperations[0].actions.filter(function(el) {
            return !el.day
          })
          if (actions.length > 0) {
            const lastAction = actions[actions.length - 1]
            const idx = actionTypes.findIndex(
              action => action === lastAction.status
            )
            if (idx !== -1) {
              setStep(idx + 1)
            } else {
              setStep(0)
            }
          } else {
            setStep(0)
          }
        }
      }
    }
  }, [actionTypes, setStep, list, currentDay])

  const nextStep = useCallback(async () => {
    setSubmitting(true)

    if (await checkStepStatus()) {
      setDisplayAlertText(
        'This action cannot be completed at this time. Please wait and try again when you are on your way.'
      )
      setDisplayAlertTitle('Too early')
      setShowConfirmationModal(true)
      setSubmitting(false)
      return
    }

    const timeZoneId = list.pickUpLocation?.timeZoneId
    let localTime = timeZoneId ? moment().tz(timeZoneId) : moment.utc()
    let formatTime = localTime.format('YYYY-MM-DDTHH:mm:ss')
    let currentTime = moment().utc(formatTime)
    let pickUpTime = moment.utc(list.pickUpDate)

    // Calculate duration between current time and pickup
    let duration = moment.duration(pickUpTime.diff(currentTime))

    //if there is at least less one hour
    if (Math.abs(duration.asHours()) <= 1) {
    } else {
      navigator.geolocation.getCurrentPosition(
        async function(pos) {
          const geo = `${pos.coords.latitude},${pos.coords.longitude}`
          const bId = list._id
          await updateGreetActions(
            {
              action: actionTypes[step],
              geoLocation: geo,
              isLiveLocation: true,
              isArrival: isArrival,
              ...(isArrival
                ? { service: 'vip_arrival' }
                : { service: 'vip_departure' }),
              ...(list.durationType === 'daily' && list.days
                ? { day: currentDay }
                : {}),
            },
            bId
          )
          setSubmitting(false)
          setStep(step + 1)
          reloadList()
        },
        async function(error) {
          if (error.code === error.PERMISSION_DENIED) {
            const bId = list._id
            const geo = `00.00-00.00`
            await updateGreetActions(
              {
                action: actionTypes[step],
                geoLocation: geo,
                isLiveLocation: false,
                isArrival: isArrival,
                ...(isArrival
                  ? { service: 'vip_arrival' }
                  : { service: 'vip_departure' }),
                ...(list.durationType === 'daily' && list.days
                  ? { day: currentDay }
                  : {}),
              },
              bId
            )
            setSubmitting(false)
            setStep(step + 1)
            reloadList()
          }
        }
      )
    }

    // let diffTime = currentTime - timeToEvent
    // duration = moment.duration(diffTime, 'milliseconds')
    // console.log('list.bookingOperations', list.bookingOperations)
    // console.log('data', data)
    // console.log('years', duration.years())
    // console.log('months', duration.months())
    // console.log('days', duration.days())
    // console.log('hours', duration.hours())

    // if (
    //   listExists &&
    //   list.bookingOperations &&
    //   list.bookingOperations[0].actions.length
    // ) {
    //   const lastAction =
    //     list.bookingOperations[0].actions[
    //       list.bookingOperations[0].actions.length - 1
    //     ]
    //   if (lastAction.status === 'accepted') {
    //     duration = null
    //   } else {
    //     const geo = `${list.pickUpLocation.lat},${list.pickUpLocation.lng}`
    //     const { data } = await getBookingTimeZone({
    //       eventTime: lastAction.time,
    //       coordinates: geo,
    //     })
    //     let offSet = data.location.rawOffset + data.location.dstOffset
    //     let timeToEvent = data.eventTimeStamp * 1000
    //     let currentTime = new Date(
    //       (Math.floor(new Date(data.localTimeStamp * 1000) / 1000) + offSet) *
    //         1000
    //     )
    //     let diffTime = currentTime - timeToEvent
    //     duration = moment.duration(diffTime, 'milliseconds')
    //   }
    // }
    // if (await checkStepStatus()) {
    //   setDisplayAlertText(
    //     'This action cannot be completed at this time. Please wait and try again when you are on your way.'
    //   )
    //   setDisplayAlertTitle('On the way')
    //   setShowConfirmationModal(true)
    // } else if (
    //   duration &&
    //   duration.seconds() <= 30 &&
    //   duration.minutes() < 1 &&
    //   duration.hours() === 0 &&
    //   duration.days() === 0
    // ) {
    //   if (
    //     (list.type === 'airport_transfer' ||
    //       list.type === 'departure_transfer' ||
    //       list.type === 'return_transfer' ||
    //       list.type === 'chauffeur_services') &&
    //     actionTypes[step] !== 'completed'
    //   ) {
    //     switch (actionTypes[step]) {
    //       case 'on_site':
    //         setDisplayAlertText(
    //           'This action cannot be completed at this time. Please wait and try again when you are on location.'
    //         )
    //         setDisplayAlertTitle('On location')
    //         break
    //       case 'contact-made':
    //         setDisplayAlertText(
    //           'This action cannot be completed at this time. Please wait and try again when the passenger is on board.'
    //         )
    //         setDisplayAlertTitle('On board')
    //         break
    //       case 'ten_mins_away':
    //         setDisplayAlertText(
    //           'This action cannot be completed at this time. Please wait and try again when you are 10 mins away from the destination.'
    //         )
    //         setDisplayAlertTitle('10 mins away')
    //         break
    //       case 'passenger_dropped_off':
    //         setDisplayAlertText(
    //           'This action cannot be completed at this time. Please wait and try again when the passenger has been dropped off.'
    //         )
    //         setDisplayAlertTitle('Dropped off')
    //         break
    //       default:
    //         setDisplayAlertText(
    //           'This action cannot be completed at this time. Please wait and try again later'
    //         )
    //         break
    //     }
    //   }
    //   setShowConfirmationModal(true)
    // } else {
    //   navigator.geolocation.getCurrentPosition(
    //     async function(pos) {
    //       const geo = `${pos.coords.latitude},${pos.coords.longitude}`
    //       const bId = list._id
    //       await updateGreetActions(
    //         {
    //           action: actionTypes[step],
    //           geoLocation: geo,
    //           isLiveLocation: true,
    //           ...(list.durationType === 'daily' && list.days
    //             ? { day: currentDay }
    //             : {}),
    //         },
    //         bId
    //       )
    //       setSubmitting(false)
    //       setStep(step + 1)
    //       reloadList()
    //     },
    //     async function(error) {
    //       if (error.code === error.PERMISSION_DENIED) {
    //         const bId = list._id
    //         const geo = `00.00-00.00`
    //         await updateGreetActions(
    //           {
    //             action: actionTypes[step],
    //             geoLocation: geo,
    //             isLiveLocation: false,
    //             ...(list.durationType === 'daily' && list.days
    //               ? { day: currentDay }
    //               : {}),
    //           },
    //           bId
    //         )
    //         setSubmitting(false)
    //         setStep(step + 1)
    //         reloadList()
    //       }
    //     }
    //   )
    //   if (actionTypes[step] === 'on_the_way') {
    //     const geo = `${list.pickUpLocation.lat},${list.pickUpLocation.lng}`
    //     const { data } = await getBookingTimeZone({
    //       eventTime: list.pickUpDate,
    //       coordinates: geo,
    //     })
    //     let offSet = data.location.rawOffset + data.location.dstOffset
    //     let timeToEvent = data.eventTimeStamp * 1000
    //     let currentTime = new Date(
    //       (Math.floor(new Date(data.localTimeStamp * 1000) / 1000) + offSet) *
    //         1000
    //     )
    //     let diffTime = timeToEvent - currentTime

    //     let durationToEvent = moment
    //       .duration(diffTime, 'milliseconds')
    //       .asMilliseconds()

    //     let durationOfEvent = 0
    //     if (list.type === 'chauffeur_services') {
    //       if (list.durationType === 'hourly') {
    //         durationOfEvent = list.duration * 3600000
    //       } else {
    //         durationOfEvent = list.duration[0] * 3600000
    //       }
    //     } else {
    //       if (list.tripInfo) {
    //         durationOfEvent = list.tripInfo.duration * 1000
    //       }
    //     }

    //     let durationAfterEvent = 2700000 // 45 minutes

    //     let geolocationDuration =
    //       durationToEvent + durationOfEvent + durationAfterEvent
    //     const getLocationUpdates = invoke.bind('getLocationUpdates')
    //     const callGeolocation = await getLocationUpdates(
    //       geolocationDuration,
    //       bookingId
    //     )
    //   } else if (actionTypes[step] === 'passenger_dropped_off') {
    //     const removeLocationUpdates = invoke.bind('removeLocationUpdates')
    //     const removeGeoLocation = await removeLocationUpdates()
    //   }
    // }
  }, [list, step, setStep, actionTypes])

  const onConfirmationModal = async type => {
    setShowConfirmationModal(false)
    setSubmitting(false)
  }
  const checkStepStatus = async () => {
    const geo = `${list.pickUpLocation.lat},${list.pickUpLocation.lng}`
    const { data } = await getBookingTimeZone({
      eventTime:
        list.durationType === 'daily' && list.days
          ? list.days[currentDay - 1].pickUpDate
          : list.pickUpDate,
      coordinates: geo,
    })

    let offSet = data.location.rawOffset + data.location.dstOffset
    let timeToEvent = data.eventTimeStamp * 1000
    let currentTime = new Date(
      (Math.floor(new Date(data.localTimeStamp * 1000) / 1000) + offSet) * 1000
    )
    let diffTime = timeToEvent - currentTime

    let duration = moment.duration(diffTime, 'milliseconds')
    // Block if more than 24 hours away; raw hours comparison handles cross-midnight
    // flights (1 AM, 2 AM, etc.) without any same-day calendar check.
    return duration.asHours() > 24
  }

  useEffect(() => {
    if (listExists) {
      if (list.durationType === 'daily' && list.days) {
        for (let i in list.days) {
          let currentDate = moment.utc(new Date())
          let dayDate = moment.utc(list.days[i].pickUpDate).startOf('day')

          if (currentDate.isSameOrAfter(dayDate)) {
            setCurrentDay(parseInt(i) + 1)
          }
        }
      }
    }
  }, [list])

  useEffect(() => {
    const checkDriverExists = async () => {
      const url = `external/findDriver/${list.greeter.phone}`
      const { data } = await api.get(url)

      setDriverExists(data.valid)
    }
    const checkBookingOperations = async actions => {
      _.each(actions, item => {
        if (item.status === 'on_site') setUpdateOnSite(item)
        if (item.status === 'contact_made') setUpdateContactMade(item)
        if (item.status === 'service_complete') setUpdateServiceComplete(item)
      })
    }
    const fetchGeoData = async startTime => {
      const geo = `${list.pickUpLocation.lat},${list.pickUpLocation.lng}`
      const { data } = await getBookingTimeZone({
        eventTime: startTime,
        coordinates: geo,
      })
      setGeoData(data)
    }
    if (listExists && list.pickUpDate) fetchGeoData(list.pickUpDate)
    if (listExists && list.greeter && list.greeter.phone) checkDriverExists()

    if (
      listExists &&
      list.bookingOperations &&
      list.bookingOperations[0].actions
    )
      checkBookingOperations(list.bookingOperations[0].actions)
  }, [list, currentDay])

  // useEffect(() => {
  //   const checkBookingTime = async count => {
  //     let offSet = geoData.location.rawOffset + geoData.location.dstOffset
  //     let timeToEvent = geoData.eventTimeStamp * 1000
  //     let currentTime = new Date(
  //       (Math.floor(new Date(geoData.localTimeStamp * 1000) / 1000) + offSet) *
  //         1000
  //     )
  //     let diffTime = timeToEvent - currentTime - count * 1000
  //     let duration = moment.duration(diffTime, 'milliseconds')

  //     let months = duration.months()
  //     let days = duration.days()
  //     let hours = duration.hours()
  //     let minutes = duration.minutes()
  //     let seconds = duration.seconds()

  //     if (months > 0) {
  //       days += months * 30
  //     }

  //     if (days >= 0 && hours >= 0 && minutes >= 0 && seconds >= 0) {
  //       setBookingTimer({
  //         days: days,
  //         hours: hours,
  //         minutes: minutes,
  //         seconds: seconds,
  //       })
  //     } else {
  //       let diffTimeAfter = currentTime - timeToEvent - count * 1000
  //       let durationAfter = moment.duration(diffTimeAfter, 'milliseconds')

  //       let monthsAfter = durationAfter.months()
  //       let daysAfter = durationAfter.days()
  //       let hoursAfter = durationAfter.hours()
  //       let minutesAfter = durationAfter.minutes()
  //       let secondsAfter = durationAfter.seconds()

  //       if (monthsAfter > 0) {
  //         daysAfter += monthsAfter * 30
  //       }

  //       setBookingTimerAfter({
  //         days: daysAfter,
  //         hours: hoursAfter,
  //         minutes: minutesAfter,
  //         seconds: secondsAfter,
  //       })
  //     }

  //     if (days === 0 && hours <= 2) setBookingInTwoHours(true)

  //     if (days < 1) setBookingInOneDay(true)

  //     if (hours >= 0 && minutes >= 0 && seconds >= 0) {
  //       if (hours < 10) hours = '0' + hours.toString()
  //       if (minutes < 10) minutes = '0' + minutes.toString()
  //       if (seconds < 10) seconds = '0' + seconds.toString()

  //       setBookingTimeLeft(`${hours}:${minutes}:${seconds}`)
  //     }
  //   }

  //   let count = 0

  //   const bookingInterval = setInterval(() => {
  //     if (listExists && geoData) {
  //       checkBookingTime(count)
  //       count += 1
  //     }
  //   }, 1000)

  //   return () => clearInterval(bookingInterval)
  // }, [geoData])

  let supplierId = null

  if (data && data.list && data.list[0]) {
    supplierId = data.list[0]._id
  }

  const getAddressElementLength = (divIndex, eleIndex) => {
    let container = document.getElementsByClassName('partner-fields')[divIndex]

    if (container) {
      let selectedElement = container.getElementsByTagName('p')[eleIndex]

      if (selectedElement && selectedElement.offsetHeight) {
        if (selectedElement && selectedElement.offsetHeight > 70) return 3
        if (selectedElement && selectedElement.offsetHeight < 25) return 1
      }
      return 2
    }
    return 2
  }

  const renderDottedBar = (addressLength, hide) => {
    if (!hide) {
      return (
        <div
          className='dotted-container'
          style={
            addressLength === 3
              ? { height: '79px' }
              : addressLength === 1
              ? { height: '32px' }
              : { height: '56px' }
          }
        >
          <svg
            style={{
              transform: 'rotate(90deg)',
            }}
            width='300px'
            height='200px'
            viewBox='0 0 300 200'
            className='dotted-line'
          >
            <line
              x1='40'
              x2='260'
              y1='100'
              y2='100'
              stroke='#8b959e'
              strokeWidth='2'
              strokeLinecap='round'
              strokeDasharray='.001, 10'
            />
          </svg>
        </div>
      )
    }
  }

  /*const getHostLink = bookingId => {
    if (apiHost === 'https://staging.rolzo.com/api') {
      return `https://partners-staging.rolzo.com/${bookingId}/b`
    } else if (apiHost === 'https://business.rolzo.com/api') {
      return `https://partners.rolzo.com/${bookingId}/b`
    } else if (apiHost === 'http://localhost:3000') {
      return `http://localhost:3002/${bookingId}/b`
    }
  }*/
  const getHostLinkVip = () => {
    const vipType = isArrival
      ? 'arrival'
      : isDeparture
      ? 'departure'
      : isTransit
      ? 'arrival'
      : ''
    return `${getPartnerOriginLink()}/${vipType}/${bookingId}/b`
  }
  //add helper functions for pending status
  const isStep1Pending = useMemo(() => {
    // Step 1 is pending if: no on_site action AND we're past pickup time
    if (updateOnSite) return false // Already done

    if (!list.pickUpDate) return false

    const now = moment()
    const pickUpTime = moment(list.pickUpDate)

    return now.isAfter(pickUpTime) // Past pickup time
  }, [updateOnSite, list.pickUpDate])

  const isStep2Pending = useMemo(() => {
    // Step 2 is pending if: on_site is done, contact_made is not done,
    // AND 15 minutes have passed since step 1
    if (!updateOnSite || updateContactMade) return false

    const onSiteTime = moment(updateOnSite.time)
    const now = moment()
    const minutesSinceStep1 = now.diff(onSiteTime, 'minutes')

    return minutesSinceStep1 >= 15
  }, [updateOnSite, updateContactMade])

  const isStep3Pending = useMemo(() => {
    // Step 3 is pending if: contact_made is done, service_complete is not done,
    // AND 1 hour has passed since step 2
    if (!updateContactMade || updateServiceComplete) return false

    const contactMadeTime = moment(updateContactMade.time)
    const now = moment()
    const minutesSinceStep2 = now.diff(contactMadeTime, 'minutes')

    return minutesSinceStep2 >= 60 // 1 hour = 60 minutes
  }, [updateContactMade, updateServiceComplete])

  //simplified steps definition
  const steps = useMemo(() => {
    return [
      {
        id: 'onSite',
        number: 1,
        updateStatus: updateOnSite,
        label: `On site at ${isArrival || isTransit ? 'Arrival' : 'Departure'}`,
        questionLabel: `Are you on site at ${
          isArrival || isTransit ? 'Arrival' : 'Departure'
        }?`,
        showTimestamp: !checkBookingAfterADay(list.pickUpDate) && !updateOnSite,
        isPending: isStep1Pending,
        timestamp: updateOnSite?.time,
        isCompleted: !!updateOnSite,
      },
      {
        id: 'contactedPassenger',
        number: 2,
        updateStatus: updateContactMade,
        label: 'Contact made with passenger(s)',
        questionLabel: 'Contact made with passenger(s)',
        showTimestamp:
          !checkBookingAfterADay(list.pickUpDate) &&
          !updateContactMade &&
          updateOnSite,
        isPending: isStep2Pending,
        timestamp: updateContactMade?.time,
        isCompleted: !!updateContactMade,
      },
      {
        id: 'serviceCompleted',
        number: 3,
        updateStatus: updateServiceComplete,
        label: 'Service complete',
        questionLabel: 'Service complete',
        showTimestamp: false,
        isPending: isStep3Pending,
        timestamp: updateServiceComplete?.time,
        isCompleted: !!updateServiceComplete,
      },
    ]
  }, [
    updateOnSite,
    updateContactMade,
    updateServiceComplete,
    bookingInTwoHours,
    isArrival,
    list.pickUpDate,
  ])

  //updated trip steps
  const TripStep = ({ step, isLast }) => {
    return (
      <div className='step'>
        <div className='v-stepper'>
          <div
            className={
              step.isCompleted ? 'update-circle-filled' : 'update-circle'
            }
          />
          {!isLast && (
            <div
              className={
                step.isCompleted ? 'vertical-filled' : 'vertical-dashed'
              }
            />
          )}
        </div>
        <div className='driver-service-card-container'>
          <div
            className={`driver-service-card-item-updates ${
              step.isCompleted ? 'updates-complete indicator-black' : ''
            } ${step.isPending ? 'indicator-red' : ''}`}
          >
            <span>{step.number}</span>
            <span style={step.isPending ? { color: '#d0021b' } : {}}>
              {step.isPending ? step.questionLabel : step.label}
            </span>
            {step.isCompleted && (
              <img
                style={{ justifySelf: 'flex-end', alignSelf: 'center' }}
                width={20}
                src='/images/icons/icon-checklist-black.png'
                alt='completed'
              />
            )}
          </div>
          {step.isCompleted && step.timestamp && (
            <span className='status-update-timestamp'>
              {moment.utc(step.timestamp).format(newTimeFormat)}
            </span>
          )}
        </div>
      </div>
    )
  }

  const renderContent = () => {
    //1. get greeter info
    let greeter = isArrival
      ? list.vipArrivalGreeter || list.greeter
      : list.vipDepartureGreeter || list.greeter

    // ─── VIP Standalone: resolve fields via utility ───
    const _dispFields = resolveDispatchFields(
      list || {},
      isArrival ? 'arrival' : 'departure'
    )
    const _primaryDisp = resolvePrimaryVipDispatch(list || {})
    const _serviceFields = resolveServiceStatus(
      list || {},
      isArrival ? 'arrival' : 'departure'
    )

    //2. get vip service status

    return (
      <>
        {listExists && (
          <div className='driver-booking-container' style={{ margin: 0 }}>
            {(((isArrival || isTransit) &&
              list.vipArrivalDispatchStatus === 'accepted' &&
              list.vipArrivalDispatch) ||
              (isDeparture &&
                list.vipDepartureDispatchStatus === 'accepted' &&
                list.vipDepartureDispatch)) && (
              <div className='tabs-container' style={{ width: 'fit-content' }}>
                <div className='d-flex justify-content-start'>
                  <div
                    className='custom-tabs-nav-driver light-tabs nav'
                    style={{ borderBottom: 0 }}
                  >
                    <Button
                      onClick={() => changeTab(0)}
                      className={`nav-link ${selectedTab ? '' : 'active'}`}
                    >
                      Information
                    </Button>
                    <Button
                      onClick={() => changeTab(1)}
                      className={`nav-link ${!selectedTab ? '' : 'active'}`}
                    >
                      Updates
                    </Button>
                  </div>
                </div>
              </div>
            )}

            {/* complete booking banner */}
            {list.status !== 'cancellation_accepted_by_agent' &&
            list.status !== 'cancelled_by_agent' &&
            ((isArrival && list.vipArrivalDispatch) ||
              (!isArrival && list.vipDepartureDispatch)) &&
            (!list.isOperativeBranch ||
              (list.dispatch.supplierId === list.supplierInfo.supplierId &&
                list.isOperativeBranch)) &&
            updateServiceComplete &&
            list.vipDispatchStatus !== 'completed' &&
            list.vipDispatchStatus !== 'incomplete' ? (
              <BookingTimerAfterDropOff
                list={list}
                geoData={geoData}
                isArrival={isArrival}
                updateServiceComplete={updateServiceComplete}
                setShowCompleteBookingModal={setShowCompleteBookingModal}
              />
            ) : (
              <></>
            )}

            {/* Assign Chauffeur banner (before 24 hours or as soon as possilbe) */}
            {list.supplierInfo &&
            list.supplierInfo.status !== 'expired' &&
            list.supplierInfo.status !== 'declined' &&
            list.supplierInfo.status !== 'declined changes' &&
            list.status !== 'completed' &&
            list.status !== 'cancellation_accepted_by_agent' &&
            list.status !== 'cancelled_by_agent' &&
            (((isArrival || isTransit) && list.vipArrivalDispatch) ||
              (isDeparture && list.vipDepartureDispatch)) &&
            (!isLocalSupplier ||
              (isLocalSupplier && companyId === list.vipDispatch.supplierId)) &&
            // !list.partnerGreeterId &&
            (((isArrival || isTransit) && !list.vipArrivalGreeter) ||
              (isDeparture && !list.vipDepartureGreeter)) ? (
              <>
                {!checkBookingAfterADay(list.pickUpDate) ? (
                  <>
                    {!list.partnerGreeterId && (
                      <div className='partner-banner-desktop mt-4'>
                        <div className='d-flex'>
                          <div className='warning-imageContainer'>
                            <img src='/images/icons/icon-warning.png' alt='' />
                          </div>
                          <div className='partnerContainer'>
                            <p>Action required</p>
                            <span>
                              The greeter must be assigned as soon as possible.
                            </span>
                          </div>
                        </div>
                        <Button
                          className='select-chauffeur'
                          style={{ marginRight: '0em' }}
                          variant='brown'
                          onClick={() => {
                            assignGreeter()
                          }}
                        >
                          {'Assign greeter'}
                        </Button>
                      </div>
                    )}
                  </>
                ) : (
                  <div className='partner-banner-desktop-gold mt-4'>
                    <div className='d-flex'>
                      <div className='imageContainerGold'>
                        <img
                          src='/images/icons/icon-chauffeur-gold.png'
                          alt=''
                        />
                      </div>
                      <div className='partnerContainer'>
                        <span>
                          {!list.partnerGreeterId &&
                            `The
                              greeter must be assigned 24 hours before the pick-up time.'
                            `}
                        </span>
                      </div>
                    </div>
                    <Button
                      className='select-chauffeur'
                      style={{ marginRight: '0em' }}
                      variant='brown'
                      onClick={() => {
                        assignGreeter()
                      }}
                    >
                      {`Assign greeter`}
                    </Button>
                  </div>
                )}
              </>
            ) : (
              <>
                {/* Assigned chauffeur/agent banner */}
                {list.status !== 'cancellation_accepted_by_agent' &&
                  list.status !== 'cancelled_by_agent' &&
                  list.supplierInfo &&
                  list.supplierInfo.status !== 'expired' &&
                  greeter &&
                  greeter.fullName && (
                    <div className='partner-banner-desktop-grey mt-4'>
                      <div className='d-flex'>
                        <div className='imageContainer'>
                          <img src='/images/icons/icon_chauffeur.png' alt='' />
                        </div>
                        <div className='partnerContainer'>
                          <p>
                            {'Greeted by'} {greeter.fullName.split(' ')[0]}
                            {list.vipDispatch &&
                            list.supplierInfo &&
                            list.isOperativeBranch &&
                            list.vipDispatch.supplierId !==
                              list.supplierInfo.supplierId
                              ? ` · Outsourced to ${list.vipDispatch.name}`
                              : ''}
                          </p>
                          <span>{greeter.phone}</span>
                        </div>
                      </div>
                      {list.status !== 'completed' &&
                        tokenUser &&
                        tokenUser.isPartner && (
                          <img
                            style={{
                              // width: '3%',
                              // height: '2%',
                              // marginRight: '3%',
                              width: '1.75rem',
                              height: '1.75rem',
                              cursor: 'pointer',
                            }}
                            src='/images/edit_icon.png'
                            alt=''
                            onClick={() => {
                              assignGreeter()
                            }}
                          />
                        )}
                    </div>
                  )}
              </>
            )}

            {/* Partner changes banner */}
            {listExists &&
              list.status !== 'completed' &&
              list.status !== 'cancellation_accepted_by_agent' &&
              list.status !== 'cancelled_by_agent' &&
              list.supplierInfo &&
              ((isStandaloneVip &&
                list.dispatchStatus === 'accepted' &&
                list.dispatch &&
                (!list.supplierInfo.supplierId ||
                  list.dispatch.supplierId === list.supplierInfo.supplierId)) ||
                (!isStandaloneVip &&
                  list.supplierInfo.status === 'accepted' &&
                  ((isArrival &&
                    list.vipArrivalDispatch &&
                    list.vipArrivalDispatch.supplierId ===
                      list.supplierInfo.supplierId) ||
                    (!isArrival &&
                      list.vipDepartureDispatch &&
                      list.vipDepartureDispatch.supplierId ===
                        list.supplierInfo.supplierId)))) &&
              tokenUser &&
              tokenUser.isPartner &&
              bookingChanges &&
              thereAreNewChanges && (
                <>
                  <div className='partner-banner-desktop mt-4'>
                    <div className='d-flex'>
                      <div
                        className='imageContainer'
                        style={{
                          alignSelf: 'start',
                          marginTop: '20px',
                        }}
                      >
                        <img src='/images/icons/icon-warning.png' alt='' />
                      </div>
                      <div className='partnerContainer w-75'>
                        <p style={{ marginTop: '0.15rem' }}>Action required</p>
                        <span>
                          Please review and confirm the booking change(s):
                        </span>
                        <span className='mt-1'>
                          {renderBookingChanges(bookingChanges)}
                        </span>
                      </div>
                    </div>
                    <div className='d-flex'>
                      <Button
                        className='partner-btn-desktop-decline select-vehicle align-self-end'
                        style={{
                          fontWeight: '400',
                          textShadow: '0.25px 0 #a79779',
                        }}
                        onClick={() => {
                          setShowDeclineChangesConfirmationModal(true)
                        }}
                      >
                        Decline
                      </Button>
                      <Button
                        className='select-chauffeur align-self-end'
                        style={{
                          whiteSpace: 'pre',
                          marginLeft: '1em',
                          paddingRight: '1.7rem',
                          paddingLeft: '1.7rem',
                          marginRight: '0em',
                        }}
                        variant='brown'
                        onClick={() => {
                          onAcceptBookingChanges(
                            bookingChanges,
                            list._id,
                            supplierId
                          )
                        }}
                      >
                        {'Confirm change(s)'}
                      </Button>
                    </div>
                  </div>
                </>
              )}

            {/* Expired banner */}
            {list.supplierInfo && list.supplierInfo.status === 'expired' && (
              <div className='partner-banner-desktop mt-4'>
                <div className='d-flex'>
                  <div className='imageContainer'>
                    <img src='/images/icons/icon-warning.png' alt='' />
                  </div>
                  <div className='partnerContainer'>
                    <span>This offer is no longer available.</span>
                  </div>
                </div>
              </div>
            )}

            {selectedTab === 0 && (
              <>
                {isSubmitting && <LoadingSpinner />}
                <div
                  style={
                    list.vipDispatchStatus === 'outsourced'
                      ? { marginTop: '0px' }
                      : {}
                  }
                  className={
                    list.vipDispatch || list.greeter
                      ? 'driver-info-layout-banner'
                      : 'driver-info-layout'
                  }
                >
                  <div className='driver-info-column'>
                    <div className='driver-service-card'>
                      <div className='driver-service-card-header'>
                        <span>Service</span>
                        {geoData &&
                          list.status !== 'cancellation_accepted_by_agent' &&
                          list.status !== 'cancelled_by_agent' &&
                          ((list.supplierInfo &&
                            list.supplierInfo.status !== 'expired' &&
                            list.supplierInfo.status !== 'declined' &&
                            list.supplierInfo.status !== 'declined changes') ||
                            !list.supplierInfo) && (
                            <div
                              className='partner-countdown'
                              style={
                                checkBookingAfterADay(list.pickUpDate)
                                  ? { color: 'black' }
                                  : { color: '#d0021b' }
                              }
                            >
                              <BookingCountdown
                                geoData={geoData}
                                listExists={listExists}
                              />
                            </div>
                          )}
                      </div>
                      <div className='driver-service-card-body'>
                        <div className='driver-service-card-item'>
                          <span>Type</span>
                          {isTransit ? (
                            <span>VIP Meet & Greet, Transit</span>
                          ) : isArrival ? (
                            <span>VIP Meet & Greet, Arrival</span>
                          ) : (
                            <span>VIP Meet & Greet, Departure</span>
                          )}
                        </div>
                        <div className='driver-service-card-item'>
                          <span>Date and time</span>
                          <span>{`
              ${moment.utc(list.pickUpDate).format(dateFormatDetailed)},
              ${moment.utc(list.pickUpDate).format('HH:mm')}
            `}</span>
                        </div>
                        <div className='driver-service-card-item'>
                          <span>Number of passenger(s)</span>
                          <span>
                            {isStandaloneVip
                              ? standalonePassengerSummary ||
                                (list.passengerInfo &&
                                  list.passengerInfo.passenger)
                              : addonPassengerSummary ||
                                (isArrival
                                  ? list.meetAndAssist?.arrival?.vehicle
                                      ?.passengers
                                  : list.meetAndAssist?.departure?.vehicle
                                      ?.passengers)}
                          </span>
                        </div>
                        <div className='driver-service-card-item'>
                          <span>Number of luggage</span>
                          <span>
                            {isStandaloneVip
                              ? list.passengerInfo?.luggage
                              : isArrival
                              ? list.meetAndAssist?.arrival?.vehicle?.luggage
                              : list.meetAndAssist?.departure?.vehicle?.luggage}
                          </span>
                        </div>
                      </div>
                    </div>

                    {(isStandaloneVip
                      ? standaloneServiceFeatures
                      : addonServiceFeatures
                    ).length > 0 && (
                      <div className='driver-service-card'>
                        <div className='driver-service-card-header'>
                          <span>Service details</span>
                        </div>
                        <div className='driver-service-card-body'>
                          {(isStandaloneVip
                            ? standaloneServiceFeatures
                            : addonServiceFeatures
                          ).map((feature, idx) => (
                            <div
                              key={idx}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                marginBottom: '10px',
                              }}
                            >
                              <img
                                src='/images/icons/vip-circle-check.svg'
                                alt=''
                                style={{
                                  width: '18px',
                                  height: '18px',
                                  flexShrink: 0,
                                }}
                              />
                              <span
                                style={{
                                  color: '#0C0C0C',
                                  fontFamily: 'Avenir Next',
                                  fontSize: '14px',
                                  fontWeight: 400,
                                  lineHeight: '22px',
                                }}
                              >
                                {feature}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {isStandaloneVip && isTransit ? (
                      // ── Standalone VIP Transit: TWO separate cards (arrival + departure) ──
                      <>
                        {/* Arrival flight information card */}
                        <div
                          className='driver-service-card'
                          style={{ fontSize: '15px' }}
                        >
                          <div className='driver-service-card-header'>
                            <span>Arrival flight information</span>
                          </div>
                          <div className='driver-service-card-body'>
                            <div className='driver-service-card-item'>
                              <span>Airport</span>
                              <span>
                                {standaloneFlightInfo?.iata_code ||
                                  standaloneFlightInfo?.airport?.fullAddress ||
                                  '-'}
                              </span>
                            </div>
                            {standaloneFlightInfo?.terminal && (
                              <div className='driver-service-card-item'>
                                <span>Terminal</span>
                                <span>
                                  {displayTerminal(
                                    standaloneFlightInfo.terminal
                                  ) || '-'}
                                </span>
                              </div>
                            )}
                            <div className='driver-service-card-item'>
                              <span>Flight number</span>
                              <span>
                                {standaloneFlightInfo?.flightNumber?.toUpperCase()}
                              </span>
                            </div>
                            {standaloneFlightInfo?.arrivalTime && (
                              <div className='driver-service-card-item'>
                                <span>Flight arrival date and time</span>
                                <span>
                                  {`${moment
                                    .utc(standaloneFlightInfo.arrivalTime)
                                    .format(dateFormatDetailed)}, ${moment
                                    .utc(standaloneFlightInfo.arrivalTime)
                                    .format(newTimeFormat)}`}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Departure flight information card */}
                        <div
                          className='driver-service-card'
                          style={{ fontSize: '15px' }}
                        >
                          <div className='driver-service-card-header'>
                            <span>Departure flight information</span>
                          </div>
                          <div className='driver-service-card-body'>
                            <div className='driver-service-card-item'>
                              <span>Airport</span>
                              <span>
                                {transitDepartureFlightInfo?.iata_code ||
                                  transitDepartureFlightInfo?.airport
                                    ?.fullAddress ||
                                  '-'}
                              </span>
                            </div>
                            {transitDepartureFlightInfo?.terminal && (
                              <div className='driver-service-card-item'>
                                <span>Terminal</span>
                                <span>
                                  {displayTerminal(
                                    transitDepartureFlightInfo.terminal
                                  ) || '-'}
                                </span>
                              </div>
                            )}
                            <div className='driver-service-card-item'>
                              <span>Flight number</span>
                              <span>
                                {transitDepartureFlightInfo?.flightNumber?.toUpperCase()}
                              </span>
                            </div>
                            {transitDepartureFlightInfo?.departureTime && (
                              <div className='driver-service-card-item'>
                                <span>Flight departure date and time</span>
                                <span>
                                  {`${moment
                                    .utc(
                                      transitDepartureFlightInfo.departureTime
                                    )
                                    .format(dateFormatDetailed)}, ${moment
                                    .utc(
                                      transitDepartureFlightInfo.departureTime
                                    )
                                    .format(newTimeFormat)}`}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    ) : (
                      // ── Existing single-leg card (legacy + standalone VIP arrival/departure) ──
                      <div
                        className='driver-service-card'
                        style={{ fontSize: '15px' }}
                      >
                        <div className='driver-service-card-header'>
                          <span>Flight information</span>
                        </div>
                        <div className='driver-service-card-body'>
                          <div className='driver-service-card-item'>
                            <span>Airport</span>
                            <span>
                              {isStandaloneVip
                                ? standaloneFlightInfo?.iata_code ||
                                  standaloneFlightInfo?.airport?.fullAddress ||
                                  '-'
                                : isArrival
                                ? list.meetAndAssist?.arrival?.iata_code
                                : list.meetAndAssist?.departure?.iata_code}
                            </span>
                          </div>
                          {isStandaloneVip
                            ? standaloneFlightInfo?.terminal && (
                                <div className='driver-service-card-item'>
                                  <span>Terminal</span>
                                  <span>
                                    {displayTerminal(
                                      standaloneFlightInfo.terminal
                                    ) || '-'}
                                  </span>
                                </div>
                              )
                            : (isArrival
                                ? list.airportPickUpInfo?.terminal
                                : list.airportDropOffInfo?.terminal) && (
                                <div className='driver-service-card-item'>
                                  <span>Terminal</span>
                                  <span>
                                    {(isArrival
                                      ? list.airportPickUpInfo.terminal
                                      : list.airportDropOffInfo.terminal
                                    )?.replace(/^T(\d)/i, '$1')}
                                  </span>
                                </div>
                              )}
                          <div className='driver-service-card-item'>
                            <span>Flight number</span>
                            <span>
                              {isStandaloneVip
                                ? [
                                    standaloneFlightInfo?.flightNumber?.toUpperCase(),
                                  ]
                                    .filter(Boolean)
                                    .join(' ')
                                : list?.airportPickUpInfo?.flightNumber?.toUpperCase() ||
                                  list?.airportDropOffInfo?.flightNumber?.toUpperCase()}
                            </span>
                          </div>
                          {isStandaloneVip && standaloneFlightDateTime && (
                            <div className='driver-service-card-item'>
                              <span>
                                {isArrival
                                  ? 'Flight arrival date and time'
                                  : 'Flight departure date and time'}
                              </span>
                              <span>
                                {`${moment
                                  .utc(standaloneFlightDateTime)
                                  .format(dateFormatDetailed)}, ${moment
                                  .utc(standaloneFlightDateTime)
                                  .format(newTimeFormat)}`}
                              </span>
                            </div>
                          )}
                          {!isStandaloneVip && list.pickUpDate && (
                            <div className='driver-service-card-item'>
                              <span>
                                {isArrival
                                  ? 'Flight arrival date and time'
                                  : 'Flight departure date and time'}
                              </span>
                              <span>
                                {`${moment
                                  .utc(list.pickUpDate)
                                  .format(dateFormatDetailed)}, ${moment
                                  .utc(list.pickUpDate)
                                  .format(newTimeFormat)}`}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className='driver-info-column'>
                    {list.vipDispatchStatus === 'accepted' && (
                      <>
                        {!isStandaloneVip &&
                          (addonPassengers.length > 0 ? (
                            renderVipPartnerPassengerCards(
                              addonPassengers,
                              list,
                              downloadVipFile
                            )
                          ) : (
                            // Fallback for legacy bookings without stored passengers.
                            <div className='driver-service-card'>
                              <div
                                className='driver-service-card-header'
                                style={{ fontSize: '15px' }}
                              >
                                Passenger
                              </div>
                              <div className='driver-service-card-body'>
                                <div className='driver-service-card-item'>
                                  <span>Guest name</span>
                                  <span>
                                    {list.passengerInfo
                                      ? list.passengerInfo.fullName
                                      : list.driversInfo
                                      ? list.driversInfo[0].fullName
                                      : ''}
                                  </span>
                                </div>
                                <div className='driver-service-card-item'>
                                  <span>Phone number</span>
                                  <span>
                                    {list.passengerInfo
                                      ? list.passengerInfo.phone
                                      : list.driversInfo
                                      ? list.driversInfo[0].phone
                                      : ''}
                                  </span>
                                </div>
                              </div>
                            </div>
                          ))}

                        {list.serviceNotes && list.serviceNotes !== '' ? (
                          <div className='driver-service-card'>
                            <div className='driver-service-card-header'>
                              <span>Notes</span>
                            </div>
                            <p className='mt-3'>{list.serviceNotes}</p>
                          </div>
                        ) : (
                          <></>
                        )}

                        {assignedChauffeur ? (
                          <div className='driver-service-card'>
                            <div
                              className='driver-service-card-header'
                              style={{ fontSize: '15px' }}
                            >
                              Chauffeur
                            </div>
                            <div className='driver-service-card-body'>
                              <div className='driver-service-card-item'>
                                <span>Chauffeur's name</span>
                                <span>{assignedChauffeur.fullName}</span>
                              </div>
                              <div className='driver-service-card-item'>
                                <span>Phone number</span>
                                <span>{assignedChauffeur.phone}</span>
                              </div>
                              <div className='driver-service-card-item'>
                                <span>Vehicle</span>
                                <span>{assignedChauffeurVehicle}</span>
                              </div>
                              <div className='driver-service-card-item'>
                                <span>Plate number</span>
                                <span>{assignedChauffeur.plateNo}</span>
                              </div>
                            </div>
                          </div>
                        ) : (
                          !isStandaloneVip && (
                            <div className='driver-service-card'>
                              <div
                                className='driver-service-card-header'
                                style={{ fontSize: '15px' }}
                              >
                                <span>Chauffeur</span>
                              </div>
                              <p className='mt-3' style={{ fontSize: '15px' }}>
                                This booking includes{' '}
                                {getLabelFromValue(
                                  defaultBookingServicePartner,
                                  list.bookingType || list.type
                                )}{' '}
                                service. The chauffeur's name and phone number
                                will be shared once assigned.
                              </p>
                            </div>
                          )
                        )}

                        {isStandaloneVip &&
                          standalonePassengers.length > 0 &&
                          renderVipPartnerPassengerCards(
                            standalonePassengers,
                            list,
                            downloadVipFile
                          )}

                        {/* Add-on VIP pick-up instructions — matches standalone layout
                            with icon + styled paragraph. Standalone VIP has its own
                            block below (isStandaloneVip && changesSupplierAccepted). */}
                        {!isStandaloneVip && (
                          <div className='driver-service-card'>
                            <div
                              className='driver-service-card-header'
                              style={{ fontSize: '15px' }}
                            >
                              <span>Pick-up instructions</span>
                            </div>
                            <div
                              className='d-flex align-items-start mt-3'
                              style={{ gap: '8px' }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  width: '22px',
                                  height: '24px',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  flexShrink: 0,
                                }}
                              >
                                <svg
                                  width='11'
                                  height='11'
                                  viewBox='0 0 11 11'
                                  fill='none'
                                  xmlns='http://www.w3.org/2000/svg'
                                  xmlnsXlink='http://www.w3.org/1999/xlink'
                                >
                                  <rect
                                    width='11'
                                    height='11'
                                    fill='url(#pickup_icon_desktop_ao)'
                                  />
                                  <defs>
                                    <pattern
                                      id='pickup_icon_desktop_ao'
                                      patternContentUnits='objectBoundingBox'
                                      width='1'
                                      height='1'
                                    >
                                      <use
                                        xlinkHref='#pickup_img_desktop_ao'
                                        transform='scale(0.0166667)'
                                      />
                                    </pattern>
                                    <image
                                      id='pickup_img_desktop_ao'
                                      width='60'
                                      height='60'
                                      preserveAspectRatio='none'
                                      xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAABVZJREFUaEPlW01sG0UUfm8dYy/e2TjCiam5IDWiQoITB0AqTXPhRyqqQCCUcig3JMQBSEECKf1JEQdIgANC4kYPNEIgUEUl4EKhrQQcegIJgYLKBYMToyQ7a7xOvPvQi9aR6yTeGduJI3akPc2b9963M/v+5i3CDo1CoXBzpVI5GATBPQBwIHxuBQBBRILFIqIEAH7+BoBf+TEM41omk7laLBb/3QnVsJdM8/n8SLVaPUZEjxPRvQBwU4f8VxHxR0T8zDTN86VSaaFDPpuW9QSwZVmHEPFlInoYAAZ6pVzIp46IXxHRW67rXu6Wd1eAs9nsuO/700R0sFtFVNYj4tVEIjG1vLz8rQr9VjQdAc7lcvs8z5sFgIlOBXe5bi6dTk+Wy+W/dPloA7Zt+xEimiOiQV1hvaRHxBVEnHAc50sdvlqAhRCTRPQmABg6QnaQNkDEV6SUfNqUhhLg0dHRVKlU+oCIjitx3WUiRDyXz+efnZ+fr0WJjgRsWdYwIl4govujmPVzHhG/J6KjrusuttOjLeBwZy/tdbANgAw6n8+Pt9vptoCFEB92e4wR8XcAuICI1wzDKPq+X0ylUuvWtVar7UskEoUgCApExBHZUSLa381J4eMtpXxmOx7bAg4N1EyHwjkyei+ZTH6+tLT0sw6PoaGhu9bW1h4DgOcBYERnbdNOn9jOkG0JmF1PEAQXda0xIrqIOJtKpWYWFxfdTpRtrBkeHrZqtdoJImLPYGnyCgzDOLKVy9oEmIOKWq32i66fDePe5xYWFkqayrUlHxkZyVer1fc5Ptfhy346lUrd2RqcbAJsWdZ5zQiKDMOYXllZOYOIpKOUKi0R4eDg4KkgCE5ykqW6DgDmXNc91kx/w2KOjev1+jcaDKsAcNx13U801nRMalnWkwBwDgBMVSYDAwPjzbH3DYCFEFc0EgHezad2C2wDYAj6Y9Wd5oRDSvnAhkFrYjQGAMpZiGEYZxzHOa36pntJZ9v26SAITmnwPOy67ndMv7HDQogviOiIChM2UI7jPLFT32yUDvxN27b9qaohQ8SLUspHNwBzpaJSqfypkryz6zFNc7TX1jgKZOt8aL3nFV1WPZPJ3MaVk/Udtm37hSAI3lER2s+j3KqfztE2DONFx3HeXQcshLhMRBsfdhvgC6Zp7u82qFB5sSo0HJxUq1UOXSMjMkS8IqU8hFxddBxnSbHgNuW67usqyuwWjWVZUwAwrSBv1bbtIXboD/q+/7XCAkgmk3frxsYqfLuhCWPvn1R4JBKJh1AI8SoRvRG1gLMeKeVoFF0/5oUQbLwisyxEfI0BK6WAiPi2lHKyH4CiZAohZonopSg6Th0ZMFcK7osiNgzjacdxOM7ec8O27WNBEHwUpRgi/sCArxPR7VHErTFpFP1uzmez2cP1ev1SlExE/IMBl4noFgXiA1LK36Lo+jEvhLiDiPhuqu1AxH/Qsiyu9EXeAZmmKfaK/21FFfpjvpSLGqvKgNPptF0ul1WYRgnt+XwulxOe5zkKjFfjd6TjaLRi55ZiF3jEK7SMXfKgmR6edF33rIL53zUS7fSQNYtVAYABx67EE7siXnis41OmZcDcawUA68VqldHP6qVOtTLEMtbo8YrvVQu/idhdpoVHOz7XpQw4dhfioV+OT8tDw0LHqqmlCbRS6tjOjW3VtpROp4u8xvO8wp5pW2KFYteYFlrt+LQeNo5qrJpLm7/P2LQPN4OOVYN4A3isfgFo3m2+xPJ9/6xGb5dKIrYtTd9+8mjVyLKsMUTkRtCd/I1nptFr1c1b0+lbjJTDrUSe503873/U2upN7NVf8f4DbFWNFsogag4AAAAASUVORK5CYII='
                                    />
                                  </defs>
                                </svg>
                              </div>
                              <p
                                style={{
                                  color: '#000',
                                  fontFamily: '"Avenir Next"',
                                  fontSize: '16px',
                                  fontStyle: 'normal',
                                  fontWeight: 400,
                                  lineHeight: '150%',
                                  margin: 0,
                                }}
                              >
                                Please meet the passenger(s) in{' '}
                                {isArrival ? 'Arrivals' : 'Departures'} with the
                                name-board:{' '}
                                {list.airportPickUpInfo
                                  ? list.airportPickUpInfo.pickUpSign
                                  : list.passengerInfo
                                  ? list.passengerInfo.lastName
                                  : list.driversInfo
                                  ? list.driversInfo[0].lastName
                                  : ''}
                                .
                                {(isArrival
                                  ? list.meetAndAssist?.arrival?.iata_code
                                  : list.meetAndAssist?.departure
                                      ?.iata_code) && (
                                  <>
                                    {' '}
                                    (
                                    {isArrival
                                      ? list.meetAndAssist?.arrival?.iata_code
                                      : list.meetAndAssist?.departure
                                          ?.iata_code}
                                    )
                                  </>
                                )}
                              </p>
                            </div>
                            {list.supplierInfo &&
                              list.supplierInfo.status === 'accepted' &&
                              ((list.airportPickUpInfo &&
                                list.airportPickUpInfo.flightType ===
                                  'commercial') ||
                                list.trainPickUpInfo ||
                                (list.shipPickUpInfo &&
                                  list.shipPickUpInfo.shipType ===
                                    'cruise')) && (
                                <div className='name-board'>
                                  <Button
                                    className='partner-btn-desktop-secondary select-vehicle'
                                    variant='brown'
                                    onClick={() => {
                                      generatePdf()
                                    }}
                                  >
                                    Get PDF name-board
                                  </Button>
                                </div>
                              )}
                          </div>
                        )}
                      </>
                    )}

                    {(isStandaloneVip
                      ? !isStandaloneAccepted && standalonePassengers
                      : list.vipDispatchStatus !== 'accepted' && addonPassengers
                    ).length > 0 &&
                      renderVipPartnerPassengerCards(
                        isStandaloneVip
                          ? standalonePassengers
                          : addonPassengers,
                        list,
                        downloadVipFile,
                        {
                          showName: false,
                          showPhone: false,
                          showDocuments: false,
                        }
                      )}

                    {isStandaloneVip && changesSupplierAccepted && (
                      <div className='driver-service-card'>
                        <div
                          className='driver-service-card-header'
                          style={{ fontSize: '15px' }}
                        >
                          <span>Pick-up instructions</span>
                        </div>
                        <div
                          className='d-flex align-items-start mt-3'
                          style={{ gap: '8px' }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              width: '22px',
                              height: '24px',
                              justifyContent: 'center',
                              alignItems: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <svg
                              width='11'
                              height='11'
                              viewBox='0 0 11 11'
                              fill='none'
                              xmlns='http://www.w3.org/2000/svg'
                              xmlnsXlink='http://www.w3.org/1999/xlink'
                            >
                              <rect
                                width='11'
                                height='11'
                                fill='url(#pickup_icon_desktop_sv)'
                              />
                              <defs>
                                <pattern
                                  id='pickup_icon_desktop_sv'
                                  patternContentUnits='objectBoundingBox'
                                  width='1'
                                  height='1'
                                >
                                  <use
                                    xlinkHref='#pickup_img_desktop_sv'
                                    transform='scale(0.0166667)'
                                  />
                                </pattern>
                                <image
                                  id='pickup_img_desktop_sv'
                                  width='60'
                                  height='60'
                                  preserveAspectRatio='none'
                                  xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAABVZJREFUaEPlW01sG0UUfm8dYy/e2TjCiam5IDWiQoITB0AqTXPhRyqqQCCUcig3JMQBSEECKf1JEQdIgANC4kYPNEIgUEUl4EKhrQQcegIJgYLKBYMToyQ7a7xOvPvQi9aR6yTeGduJI3akPc2b9963M/v+5i3CDo1CoXBzpVI5GATBPQBwIHxuBQBBRILFIqIEAH7+BoBf+TEM41omk7laLBb/3QnVsJdM8/n8SLVaPUZEjxPRvQBwU4f8VxHxR0T8zDTN86VSaaFDPpuW9QSwZVmHEPFlInoYAAZ6pVzIp46IXxHRW67rXu6Wd1eAs9nsuO/700R0sFtFVNYj4tVEIjG1vLz8rQr9VjQdAc7lcvs8z5sFgIlOBXe5bi6dTk+Wy+W/dPloA7Zt+xEimiOiQV1hvaRHxBVEnHAc50sdvlqAhRCTRPQmABg6QnaQNkDEV6SUfNqUhhLg0dHRVKlU+oCIjitx3WUiRDyXz+efnZ+fr0WJjgRsWdYwIl4govujmPVzHhG/J6KjrusuttOjLeBwZy/tdbANgAw6n8+Pt9vptoCFEB92e4wR8XcAuICI1wzDKPq+X0ylUuvWtVar7UskEoUgCApExBHZUSLa381J4eMtpXxmOx7bAg4N1EyHwjkyei+ZTH6+tLT0sw6PoaGhu9bW1h4DgOcBYERnbdNOn9jOkG0JmF1PEAQXda0xIrqIOJtKpWYWFxfdTpRtrBkeHrZqtdoJImLPYGnyCgzDOLKVy9oEmIOKWq32i66fDePe5xYWFkqayrUlHxkZyVer1fc5Ptfhy346lUrd2RqcbAJsWdZ5zQiKDMOYXllZOYOIpKOUKi0R4eDg4KkgCE5ykqW6DgDmXNc91kx/w2KOjev1+jcaDKsAcNx13U801nRMalnWkwBwDgBMVSYDAwPjzbH3DYCFEFc0EgHezad2C2wDYAj6Y9Wd5oRDSvnAhkFrYjQGAMpZiGEYZxzHOa36pntJZ9v26SAITmnwPOy67ndMv7HDQogviOiIChM2UI7jPLFT32yUDvxN27b9qaohQ8SLUspHNwBzpaJSqfypkryz6zFNc7TX1jgKZOt8aL3nFV1WPZPJ3MaVk/Udtm37hSAI3lER2s+j3KqfztE2DONFx3HeXQcshLhMRBsfdhvgC6Zp7u82qFB5sSo0HJxUq1UOXSMjMkS8IqU8hFxddBxnSbHgNuW67usqyuwWjWVZUwAwrSBv1bbtIXboD/q+/7XCAkgmk3frxsYqfLuhCWPvn1R4JBKJh1AI8SoRvRG1gLMeKeVoFF0/5oUQbLwisyxEfI0BK6WAiPi2lHKyH4CiZAohZonopSg6Th0ZMFcK7osiNgzjacdxOM7ec8O27WNBEHwUpRgi/sCArxPR7VHErTFpFP1uzmez2cP1ev1SlExE/IMBl4noFgXiA1LK36Lo+jEvhLiDiPhuqu1AxH/Qsiyu9EXeAZmmKfaK/21FFfpjvpSLGqvKgNPptF0ul1WYRgnt+XwulxOe5zkKjFfjd6TjaLRi55ZiF3jEK7SMXfKgmR6edF33rIL53zUS7fSQNYtVAYABx67EE7siXnis41OmZcDcawUA68VqldHP6qVOtTLEMtbo8YrvVQu/idhdpoVHOz7XpQw4dhfioV+OT8tDw0LHqqmlCbRS6tjOjW3VtpROp4u8xvO8wp5pW2KFYteYFlrt+LQeNo5qrJpLm7/P2LQPN4OOVYN4A3isfgFo3m2+xPJ9/6xGb5dKIrYtTd9+8mjVyLKsMUTkRtCd/I1nptFr1c1b0+lbjJTDrUSe503873/U2upN7NVf8f4DbFWNFsogag4AAAAASUVORK5CYII='
                                />
                              </defs>
                            </svg>
                          </div>
                          <p
                            style={{
                              color: '#000',
                              fontFamily: '"Avenir Next"',
                              fontSize: '16px',
                              fontStyle: 'normal',
                              fontWeight: 400,
                              lineHeight: '150%',
                              margin: 0,
                            }}
                          >
                            Please meet the passenger(s) in{' '}
                            {isArrival || isTransit ? 'Arrivals' : 'Departures'}{' '}
                            with the name-board:{' '}
                            {list.airportPickUpInfo
                              ? list.airportPickUpInfo.pickUpSign
                              : list.passengerInfo
                              ? list.passengerInfo.lastName
                              : list.driversInfo
                              ? list.driversInfo[0].lastName
                              : ''}
                            .
                            {(isArrival || isTransit
                              ? list.meetAndAssist?.arrival?.iata_code
                              : list.meetAndAssist?.departure?.iata_code) && (
                              <>
                                {' '}
                                (
                                {isArrival || isTransit
                                  ? list.meetAndAssist?.arrival?.iata_code
                                  : list.meetAndAssist?.departure?.iata_code}
                                )
                              </>
                            )}
                          </p>
                        </div>
                        {(list.arrivalFlightInfo ||
                          list.departureFlightInfo) && (
                          <div className='name-board'>
                            <Button
                              className='partner-btn-desktop-secondary select-vehicle'
                              variant='brown'
                              onClick={() => {
                                generatePdf()
                              }}
                            >
                              Get PDF name-board
                            </Button>
                          </div>
                        )}
                      </div>
                    )}

                    {tokenUser && tokenUser.isPartner && (
                      <div className='driver-service-card'>
                        <div className='driver-service-card-header'>
                          <span>Terms</span>
                        </div>

                        <div className='driver-service-card-body'>
                          <div className='driver-service-card-item'>
                            <span>
                              <span>Free cancellation</span>{' '}
                              <TooltipOnHover
                                delay={200}
                                placement='right-start'
                                isMobileBrowser={isMobileBrowser}
                                onMouseEnter={() => {}}
                                component={
                                  <div>
                                    If an accepted booking gets cancelled before
                                    the booking commences, the client shall
                                    receive a cancellation refund if applicable.
                                  </div>
                                }
                              >
                                <img
                                  className={'new-info-icon'}
                                  style={{
                                    marginLeft: '0.5rem',
                                    marginTop: '0.156rem',
                                    height: '0.938rem',
                                  }}
                                  src='/images/icons/new-info-icon.png'
                                  alt=''
                                />
                              </TooltipOnHover>
                            </span>
                            <span>
                              {resolveCancellationPolicy(list)?.cancellation}{' '}
                              before pick-up
                            </span>
                          </div>
                          {isStandaloneVip
                            ? showHoursIncluded && (
                                <div className='driver-service-card-item'>
                                  <span>Hours included</span>
                                  <span>
                                    {list.vipRate?.hoursIncluded ?? 3} hours
                                  </span>
                                </div>
                              )
                            : renderAddonHoursIncludedRow(list, isArrival)}
                        </div>
                      </div>
                    )}
                    {list.supplierInfo &&
                    list.supplierInfo.buyingPrice &&
                    !isMobileBrowser ? (
                      <div className='driver-service-card'>
                        <PartnerPricingDetails
                          serviceType={vipLegFull}
                          supplierInfo={list.supplierInfo}
                          dispatch={list.vipDispatch}
                          charges={list.partnerCharges}
                          bookingId={bookingId}
                          bookingPartner={list.vipDispatch}
                          reloadList={reloadList}
                          isLocalSupplier={list.isOperativeBranch}
                          vipDispatchStatus={list.vipDispatchStatus}
                        />
                      </div>
                    ) : (
                      <></>
                    )}

                    {!isStandaloneAccepted &&
                    (isArrival || isTransit
                      ? !list.vipArrivalDispatch
                      : !list.vipDepartureDispatch) &&
                    list.supplierInfo &&
                    list.supplierInfo.status !== 'expired' &&
                    list.supplierInfo.status !== 'declined' &&
                    list.supplierInfo.status !== 'declined changes' &&
                    list.status !== 'cancellation_accepted_by_agent' &&
                    list.status !== 'cancelled_by_agent' ? (
                      <div className='partner-accept-container'>
                        {!list.isOperativeBranch ||
                        (list.isOperativeBranch &&
                          list.vipDispatchStatus !== 'outsourced') ? (
                          <p className='partner-terms'>
                            By clicking “Accept offer”, you agree to our{' '}
                            <span>
                              <a
                                target='_blank'
                                rel='noopener noreferrer'
                                href={
                                  apiHost === 'https://business.rolzo.com/api'
                                    ? 'https://rolzo.com/partners-terms'
                                    : 'https://dotcom-staging.rolzo.com/partners-terms'
                                }
                                alt=''
                              >
                                Terms of Service
                              </a>
                              .
                            </span>
                          </p>
                        ) : (
                          <></>
                        )}

                        <div className='d-flex' style={{ gap: '12px' }}>
                          {!list.isOperativeBranch ? (
                            <>
                              <Button
                                className={`${
                                  isLocalSupplier
                                    ? 'partner-btn-decline-red'
                                    : 'partner-btn-desktop-decline'
                                } select-vehicle`}
                                onClick={() => {
                                  setShowDeclineConfirmationModal(true)
                                }}
                              >
                                Decline
                              </Button>
                              <Button
                                className='select-btn select-vehicle partner-btn-desktop'
                                variant='brown'
                                onClick={() => {
                                  onAcceptBookingVIP(list._id)
                                }}
                              >
                                Accept offer
                              </Button>
                            </>
                          ) : (
                            <></>
                          )}
                          {list.isOperativeBranch ? (
                            <>
                              {list.vipDispatchStatus === 'outsourced' &&
                              list.outsourcedSuppliers ? (
                                <div style={{ marginTop: '1rem' }}>
                                  <Button
                                    className={`partner-cancel-dispatch mr-2 select-vehicle`}
                                    onClick={() => {
                                      setshowDispatchCancelModal(true)
                                    }}
                                  >
                                    Cancel outsource
                                  </Button>
                                  <Button
                                    className='select-btn select-vehicle partner-btn-desktop'
                                    variant='brown'
                                    onClick={() => {
                                      setshowDispatchModal(true)
                                    }}
                                  >
                                    Edit
                                  </Button>
                                </div>
                              ) : (
                                <>
                                  <Button
                                    className={`partner-cancel-dispatch mr-2 select-vehicle`}
                                    style={{ minWidth: '140px' }}
                                    variant='brown'
                                    onClick={() => {
                                      setshowDispatchModal(true)
                                    }}
                                  >
                                    Outsource
                                  </Button>
                                  <Button
                                    className='select-btn select-vehicle partner-btn-desktop'
                                    variant='brown'
                                    onClick={() => {
                                      onAcceptBookingVIP(list._id)
                                    }}
                                  >
                                    Accept offer
                                  </Button>
                                </>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className='partner-accept-container'>
                        {list.isOperativeBranch ? (
                          <div className=''>
                            <Button
                              className={`partner-cancel-dispatch mr-2 mt-2 select-vehicle`}
                              onClick={() => {
                                setshowDispatchCancelModal(true)
                              }}
                            >
                              Cancel dispatch
                            </Button>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                {list.isOperativeBranch ? (
                  <>
                    <Formik
                      enableReinitialize={true}
                      initialValues={null}
                      validateOnBlur={false}
                      validateOnChange={false}
                      isInitialValid
                    >
                      <DispatchPartnerModal
                        onHide={() => {
                          setshowDispatchModal(false)
                        }}
                        show={showDispatchModal && !isMobileBrowser}
                        currentItem={list}
                        updateBooking={reloadList}
                        localCurrency={list.supplierInfo.supplierCurrency}
                        dispatchedSuppliers={suppliersList}
                        supplierCurrency={list.supplierInfo.supplierCurrency}
                        buyingPrice={opSupplierPrice}
                        originalPrice={list.supplierInfo.buyingPrice}
                        bookingId={bookingId}
                        isApiBooking={list.apiBooking ? true : false}
                        serviceNotes={
                          list.serviceNotes
                            ? list.serviceNotes
                            : list.services_location_notes
                            ? list.services_location_notes
                            : ''
                        }
                      />
                    </Formik>
                    <DispatchCancelModal
                      onHide={() => {
                        setshowDispatchCancelModal(false)
                      }}
                      show={showDispatchCancelModal}
                      oneSupplier={false}
                      supplierInfo={list.supplierInfo}
                      handleCancelDispatch={onCancelDispatch}
                      islocalSupplier={true}
                      isMobileBrowser={isMobileBrowser}
                    />
                    <AdditionalChargesModal
                      show={showAddChargeModal}
                      onHide={() => {
                        setShowAddChargeModal(false)
                      }}
                      supplierCurrency={list.supplierInfo.supplierCurrency}
                      isLocalSupplier={list.isOperativeBranch}
                    />
                  </>
                ) : (
                  <></>
                )}
                <DeclineOfferModal
                  isMeetGreet={true}
                  onHide={() => {
                    setShowDeclineConfirmationModal(false)
                  }}
                  show={showDeclineConfirmationModal}
                  bookingId={bookingId}
                  supplierId={supplierId}
                  afterDecline={() => {
                    setShowDeclineConfirmationModal(false)
                    setShowDeclinedModal(true)
                    setTimeout(
                      function() {
                        setShowDeclinedModal(false)
                        history.push(
                          `${
                            Host === partnerHostLive ||
                            Host === partnerHostStaging
                              ? '/'
                              : '/partner/'
                          }driver/app/${token}/new-bookings`
                        )
                      }.bind(this),
                      1500
                    )
                  }}
                  isArrival={isArrival}
                />
                <ConfirmationModal
                  onHide={() => {
                    setShowDeclineChangesConfirmationModal(false)
                  }}
                  handleFunction={() => {
                    onDeclineBookingChanges(
                      bookingChanges,
                      list._id,
                      supplierId
                    )
                  }}
                  show={showDeclineChangesConfirmationModal}
                  confirmationText={
                    'Are you sure you want to decline the booking change(s)?'
                  }
                  declineChanges
                />
              </>
            )}

            {/* {console.log(
              'list.isDriverAndNotAccepted',
              list.isDriverAndNotAccepted
            )}
            {console.log('list.vipArrivalGreeter', list.greeter)}
            {console.log('list.supplierInfo', list.supplierInfo)} */}
            {selectedTab === 1 &&
              list.greeter &&
              (!list.supplierInfo ||
                (list.supplierInfo &&
                  list.supplierInfo.status !== 'expired' &&
                  list.supplierInfo.status !== 'declined' &&
                  list.supplierInfo.status !== 'declined changes')) &&
              list.status !== 'cancellation_accepted_by_agent' &&
              list.status !== 'cancelled_by_agent' &&
              !list.isDriverAndNotAccepted && (
                <>
                  <div
                    className={
                      (isArrival &&
                        (list.vipArrivalDispatch || list.vipArrivalGreeter)) ||
                      (!isArrival &&
                        (list.vipDepartureDispatch || list.vipDepartureGreeter))
                        ? 'driver-info-layout-banner'
                        : 'driver-info-layout'
                    }
                  >
                    <div className='driver-info-column'>
                      <div className='driver-service-card'>
                        <div className='driver-service-card-header'>
                          <span>Greeter's trip updates</span>
                        </div>
                        <div className='driver-service-card-body-container'>
                          {steps.map((step, index) => {
                            return (
                              <TripStep
                                key={step.id}
                                step={step}
                                isLast={index === steps.length - 1}
                              />
                            )
                          })}
                          <div
                            style={{
                              marginBottom: '0em',
                              paddingInline: '10px',
                            }}
                            className='driver-service-card-body-container'
                          >
                            <div
                              style={{ paddingLeft: '20px' }}
                              className='driver-service-card-container'
                            >
                              <div
                                style={{
                                  display: 'block',
                                }}
                                className={'driver-service-card-item-updates'}
                              >
                                <label>Link</label>
                                <a
                                  style={{ wordWrap: 'break-word' }}
                                  href={getHostLinkVip()}
                                  target='_blank'
                                  rel='noopener noreferrer'
                                  className='text-brown pointer-link'
                                >
                                  {getHostLinkVip()}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Download app on desktop */}
                    <div className='driver-info-column'>
                      <>
                        {(!updateOnSite ||
                          !updateContactMade ||
                          !updateServiceComplete) &&
                          bookingInTwoHours &&
                          !isLocalSupplier && (
                            <div className='driver-service-card'>
                              <div className='driver-service-card-header'>
                                <span className='caution'>
                                  <span className='caution-symbol'>!</span>
                                  Action required
                                </span>
                              </div>
                              <p className='partner-app-para'>
                                The chauffeur must complete a trip update via
                                the App.
                              </p>
                            </div>
                          )}
                        {list.greeter && !driverExists && !isStandaloneVip && (
                          <div className='driver-service-card'>
                            <div className='driver-service-card-header-app'>
                              <img
                                style={{ width: '18%' }}
                                src='/images/icons/icon-app.png'
                                alt=''
                              />
                              <span>ROLZO Partner App for greeters</span>
                            </div>
                            <div>
                              <p className='partner-app-para'>
                                {formatSentenceCase(list.greeter.fullName)} is
                                required to download the ROLZO Partner App.
                                Please note that no price will be displayed to
                                the greeter.
                              </p>
                            </div>
                            <Button
                              className='partner-btn-desktop-secondary select-vehicle'
                              variant='brown'
                              onClick={() => sendSMS()}
                            >
                              Send app download link by SMS
                            </Button>
                          </div>
                        )}
                      </>
                    </div>
                  </div>
                </>
              )}

            <CompleteTripModal
              onHide={() => {
                setShowCompleteBookingModal(false)
              }}
              show={showCompleteBookingModal}
              bookingId={bookingId}
              supplierId={
                list.supplierInfo && list.supplierInfo.supplierId
                  ? list.supplierInfo.supplierId
                  : null
              }
              isPartner={list && list.partnerOfBooking}
              number={list.number || ''}
              afterAction={() => {
                setShowCompleteBookingModal(false)
                setShowCompletedModal(true)
                setTimeout(function() {
                  setShowCompletedModal(false)
                }, 1500)
                reloadList()
              }}
              isVipService={true}
              isArrival={isArrival}
            />
          </div>
        )}
      </>
    )
  }

  const renderModalContent = () => {
    return (
      <PartnerAcceptedModal
        isBookingAccepted={showAcceptedModal}
        isBookingDeclined={showDeclinedModal}
        isBookingChangesAccpted={showAccptedChangesModal}
        isBookingChangesDeclined={showDeclinedChangesModal}
        isBookingCompleted={showCompletedModal}
      />
    )
  }

  const onCancelDispatch = async () => {
    try {
      //cancel dispatch for all partners
      if (isMobileBrowser) {
        await cancelDispatchBookingMobile(bookingId)
      } else {
        await cancelDispatchBooking(bookingId)
      }
      reloadList()
      setshowDispatchCancelModal(false)
    } catch (err) {
      console.log(err)
    }
  }

  const renderLocalSupplierActions = list => {
    // Check if the status is one of the completed types
    const isCompletedStatus = [
      'completed',
      'cancellation_accepted_by_agent',
      'cancelled_by_agent',
    ].includes(list.status)

    if (isCompletedStatus) {
      return null // Or return some default UI if needed
    }

    // Handling for outsourced bookings
    if (list.vipDispatchStatus === 'outsourced' && list.outsourcedSuppliers) {
      return (
        <div className='driver-booking-cta-footer'>
          <Button
            className='select-btn select-vehicle mb-2'
            style={{
              width: '100%',
              fontWeight: '900',
              fontSize: '16px',
              textShadow: '0.25px 0 #ffffff',
            }}
            variant='brown'
            onClick={() => setshowDispatchModal(true)}
          >
            Edit
          </Button>
          <Button
            className='partner-btn-desktop-tertiary select-vehicle'
            style={{
              width: '100%',
              fontWeight: '900',
              textShadow: '0.25px 0 #a79779',
            }}
            onClick={() => setshowDispatchCancelModal(true)}
          >
            Cancel outsource
          </Button>
        </div>
      )
    }

    // Assign vehicle or chaffuer
    if (
      list.supplierInfo &&
      list.supplierInfo.status !== 'expired' &&
      list.supplierInfo.status !== 'declined' &&
      list.supplierInfo.status !== 'declined changes' &&
      // Standalone VIP accepts via the root dispatchStatus (isStandaloneAccepted),
      // not vipArrival/vipDepartureDispatchStatus — without this it fell through to
      // the default "Accept offer" branch even after acceptance (QA 30).
      (isStandaloneAccepted ||
        (isArrival && list.vipArrivalDispatchStatus === 'accepted') ||
        (!isArrival && list.vipDepartureDispatchStatus === 'accepted'))
    ) {
      return (
        <div className='driver-booking-cta-footer'>
          {!list.partnerGreeterId &&
          !list.greeter &&
          (!list.isOperativeBranch ||
            (list.vipDispatch.supplierId === list.supplierInfo.supplierId &&
              list.isOperativeBranch)) ? (
            <Button
              className='select-btn select-vehicle mb-2'
              style={{
                width: '100%',
                fontWeight: '900',
                fontSize: '16px',
                textShadow: '0.25px 0 #ffffff',
              }}
              variant='brown'
              onClick={() => {
                assignGreeter()
              }}
            >
              {'Assign greeter'}
            </Button>
          ) : (
            <></>
          )}
          <Button
            className='partner-btn-desktop-tertiary select-vehicle'
            style={{
              width: '100%',
              fontWeight: '900',
              textShadow: '0.25px 0 #a79779',
            }}
            onClick={() => {
              setshowDispatchCancelModal(true)
            }}
          >
            Cancel dispatch
          </Button>
        </div>
      )
    }

    // Default action buttons for non-outsourced or pending
    return (
      <div className='driver-booking-cta-footer'>
        <Button
          className='select-btn select-vehicle mb-2'
          style={{
            width: '100%',
            fontWeight: '900',
            fontSize: '16px',
            textShadow: '0.25px 0 #ffffff',
          }}
          variant='brown'
          onClick={() => onAcceptBookingVIP(list._id)}
        >
          Accept offer
        </Button>
        <Button
          className='partner-btn-desktop-tertiary select-vehicle'
          style={{
            width: '100%',
            fontWeight: '900',
            textShadow: '0.25px 0 #a79779',
          }}
          onClick={() => setshowDispatchModal(true)}
        >
          Outsource
        </Button>
      </div>
    )
  }

  if (showDispatchModal && isMobileBrowser) {
    return (
      <Formik
        enableReinitialize={true}
        initialValues={null}
        validateOnBlur={false}
        validateOnChange={false}
        isInitialValid
      >
        <DispatchPartnerModalMobile
          onHide={() => {
            setshowDispatchModal(false)
          }}
          show={showDispatchModal && !isMobileBrowser}
          currentItem={list}
          updateBooking={reloadList}
          localCurrency={list.supplierInfo.supplierCurrency}
          dispatchedSuppliers={suppliersList}
          supplierCurrency={list.supplierInfo.supplierCurrency}
          buyingPrice={opSupplierPrice}
          originalPrice={list.supplierInfo.buyingPrice}
          bookingId={bookingId}
          isApiBooking={list.apiBooking ? true : false}
          serviceNotes={
            list.serviceNotes
              ? list.serviceNotes
              : list.services_location_notes
              ? list.services_location_notes
              : ''
          }
        />
      </Formik>
    )
  }

  //For booking not found
  const renderBookingNotFound = () => {
    return <div className='text-center h5 mt-5'>Booking not found</div>
  }

  return (
    <>
      {bookingNotFound ? (
        <SmallUp>
          <DefaultDriverDesktopLayout
            data={null}
            renderContent={renderBookingNotFound}
          />
        </SmallUp>
      ) : listExists && list.number ? (
        <>
          <SmallUp>
            <DefaultDriverDesktopLayout
              data={list}
              renderContent={
                showAcceptedModal ||
                showAccptedChangesModal ||
                showCompletedModal
                  ? renderModalContent
                  : showDeclinedModal || showDeclinedChangesModal
                  ? renderModalContent
                  : renderContent
              }
            />
          </SmallUp>
          <SmallDown>
            <>
              {!showAcceptedModal &&
              !showDeclinedModal &&
              !showAccptedChangesModal &&
              !showDeclinedChangesModal &&
              !showCompletedModal ? (
                <div style={{ height: '100vh' }}>
                  <div
                    className={
                      !displaySupport
                        ? 'driver-booking-container-header-booking'
                        : 'driver-booking-container-header-booking-support'
                    }
                  >
                    <img
                      className='driver-back-icon mx-50%'
                      src='/images/icon-back.png'
                      onClick={e => {
                        redirectBookings(e)
                      }}
                      alt=''
                    />
                    <span style={{ paddingTop: '0.2em' }}>
                      Booking #{list.number}
                    </span>
                    <img
                      className=''
                      src={'/images/icons/support-icon.png'}
                      style={
                        displaySupport
                          ? { visibility: 'hidden' }
                          : { height: '5%', width: '5%', paddingTop: '0.2rem' }
                      }
                      onClick={() => {
                        history.push(
                          `${partnerLink ? '/' : '/partner/'}driver/app/${
                            isArrival ? 'arrival' : 'departure'
                          }/${token}/${bookingId}/support`
                        )
                      }}
                      alt=''
                    />
                  </div>
                  <div
                    className='driver-booking-container'
                    style={
                      selectedTab === 0
                        ? { paddingBottom: '10em', marginTop: '5em' }
                        : selectedTab === 1
                        ? { marginTop: '5em' }
                        : {}
                    }
                  >
                    {!displaySupport ? (
                      <>
                        {(list.vipArrivalDispatchStatus === 'accepted' ||
                          list.vipDepartureDispatchStatus === 'accepted') &&
                          (list.vipArrivalDispatch ||
                            list.vipDepartureDispatch) && (
                            <div className='tabs-container'>
                              <div className='d-flex justify-content-start'>
                                <div className='custom-tabs-nav-driver light-tabs nav'>
                                  <Button
                                    onClick={() => changeTab(0)}
                                    className={`nav-link ${
                                      selectedTab ? '' : 'active'
                                    }`}
                                    style={{
                                      width: '48%',
                                      top: '1px',
                                    }}
                                  >
                                    Information
                                  </Button>
                                  <Button
                                    onClick={() => changeTab(1)}
                                    className={`nav-link ${
                                      !selectedTab ? '' : 'active'
                                    }`}
                                    style={{
                                      width: 'calc(100vw - 13em)',
                                      top: '1px',
                                      position: 'absolute',
                                      left: '12rem',
                                    }}
                                  >
                                    Updates
                                  </Button>
                                </div>
                              </div>
                            </div>
                          )}
                      </>
                    ) : (
                      <>
                        <Support token={token} bookingId={bookingId} />
                      </>
                    )}

                    {/* complete booking banner (mobile) */}
                    {list.status !== 'cancellation_accepted_by_agent' &&
                    list.status !== 'cancelled_by_agent' &&
                    ((isArrival && list.vipArrivalDispatch) ||
                      (!isArrival && list.vipDepartureDispatch)) &&
                    (!list.isOperativeBranch ||
                      (list.dispatch.supplierId ===
                        list.supplierInfo.supplierId &&
                        list.isOperativeBranch)) &&
                    updateServiceComplete &&
                    list.vipDispatchStatus !== 'completed' &&
                    list.vipDispatchStatus !== 'incomplete' ? (
                      <BookingTimerAfterDropOff
                        list={list}
                        geoData={geoData}
                        isArrival={isArrival}
                        updateServiceComplete={updateServiceComplete}
                        setShowCompleteBookingModal={
                          setShowCompleteBookingModal
                        }
                      />
                    ) : (
                      <></>
                    )}

                    {/* Assign chauffeur/agent banner (before 24 hours or as soon as possilbe) (mobile) */}
                    {(selectedTab === 0 || selectedTab === 1) &&
                      list.supplierInfo &&
                      list.supplierInfo.status !== 'expired' &&
                      list.supplierInfo.status !== 'declined' &&
                      list.supplierInfo.status !== 'declined changes' &&
                      list.status !== 'completed' &&
                      list.status !== 'cancellation_accepted_by_agent' &&
                      list.status !== 'cancelled_by_agent' &&
                      list.vipDispatch &&
                      !list.partnerGreeterId &&
                      !list.greeter && (
                        <>
                          {list.vipDispatch &&
                            !list.partnerGreeterId && [
                              checkBookingAfterADay(list.pickUpDate) ? (
                                <div className='partner-banner-grey-assign mt-4'>
                                  <div className='imageContainer'>
                                    <img
                                      src='/images/icons/icon-chauffeur-gold.png'
                                      alt=''
                                    />
                                  </div>
                                  <div className='partnerContainer'>
                                    <span>
                                      {
                                        'Assign greeter 24 hours before pick-up.'
                                      }
                                    </span>
                                  </div>
                                </div>
                              ) : (
                                <div className='partner-banner mt-4'>
                                  <div className='imageContainer'>
                                    <img
                                      src='/images/icons/icon-warning.png'
                                      alt=''
                                    />
                                  </div>
                                  <div className='partnerContainer'>
                                    <span>
                                      {'The greeter is not yet assigned.'}
                                    </span>
                                  </div>
                                </div>
                              ),
                            ]}
                        </>
                      )}

                    {/* Assigned chauffeur/agent banner  (mobile) */}
                    {selectedTab === 0 &&
                      list.status !== 'cancellation_accepted_by_agent' &&
                      list.status !== 'cancelled_by_agent' &&
                      list.supplierInfo &&
                      list.supplierInfo.status !== 'expired' &&
                      list.greeter &&
                      list.greeter.fullName && (
                        <div className='partner-banner-grey mt-4'>
                          <div className='driven-by'>
                            <div className='imageContainer'>
                              <img
                                src='/images/icons/icon_chauffeur.png'
                                alt=''
                              />
                            </div>
                            <div className='partnerContainer'>
                              <p style={{ fontWeight: '900' }}>
                                {'Greeted by'}{' '}
                                {list.greeter.fullName.split(' ')[0]}
                                {list.vipDispatch &&
                                list.supplierInfo &&
                                list.isOperativeBranch &&
                                list.vipDispatch.supplierId !==
                                  list.supplierInfo.supplierId
                                  ? ` · Outsourced to ${list.vipDispatch.name}`
                                  : ''}
                              </p>
                              <p>{list.greeter.phone}</p>
                            </div>
                          </div>
                          {list.status !== 'completed' &&
                            tokenUser &&
                            tokenUser.isPartner && (
                              <img
                                style={{
                                  // width: '25px',
                                  // marginRight: '4%',
                                  width: '1.75rem',
                                  height: '1.75rem',
                                  alignSelf: 'center',
                                  cursor: 'pointer',
                                }}
                                src='/images/edit_icon.png'
                                alt=''
                                onClick={() => {
                                  assignGreeter()
                                }}
                              />
                            )}
                        </div>
                      )}

                    {/* Partner changes banner (mobile) */}
                    {listExists &&
                    list.status !== 'completed' &&
                    list.status !== 'cancellation_accepted_by_agent' &&
                    list.status !== 'cancelled_by_agent' &&
                    list.supplierInfo &&
                    changesSupplierAccepted &&
                    tokenUser &&
                    tokenUser.isPartner &&
                    bookingChanges &&
                    thereAreNewChanges ? (
                      <>
                        <div className='partner-banner-mobile mt-4'>
                          <div>
                            <div
                              className='partnerContainer'
                              style={{ fontSize: '16px' }}
                            >
                              <div className='d-flex mb-3'>
                                <div
                                  className='imageContainer'
                                  style={{
                                    alignSelf: 'start',
                                  }}
                                >
                                  <img
                                    src='/images/icons/icon-warning.png'
                                    alt=''
                                  />
                                </div>
                                <p style={{ marginTop: '0.1rem' }}>
                                  Action required
                                </p>
                              </div>
                              <span>
                                Please review and confirm the booking change(s):
                              </span>
                              <span className='mt-1'>
                                {renderBookingChanges(bookingChanges)}
                              </span>
                            </div>
                            <div
                              className='d-flex justify-content-center'
                              style={{ gridGap: '1em' }}
                            >
                              <Button
                                className='partner-btn-mobile-decline select-vehicle align-self-end mx-0'
                                style={{
                                  fontWeight: '900',
                                  textShadow: '0.25px 0 #a79779',
                                }}
                                onClick={() => {
                                  setShowDeclineChangesConfirmationModal(true)
                                }}
                              >
                                Decline
                              </Button>
                              <Button
                                className='select-chauffeur align-self-end mx-0'
                                style={{
                                  whiteSpace: 'pre',
                                  width: '100%',
                                  marginRight: '15px',
                                  fontWeight: '900',
                                  textShadow: '0.25px 0 #ffffff',
                                }}
                                variant='brown'
                                onClick={() => {
                                  onAcceptBookingChanges(
                                    bookingChanges,
                                    list._id,
                                    supplierId
                                  )
                                }}
                              >
                                {'Confirm change(s)'}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    {/* Expired banner (mobile) */}
                    {list.supplierInfo &&
                      list.supplierInfo.status === 'expired' && (
                        <div className='partner-banner-mobile mt-4'>
                          <div className='d-flex'>
                            <div className='imageContainer'>
                              <img
                                src='/images/icons/icon-warning.png'
                                alt=''
                              />
                            </div>
                            <div className='partnerContainer'>
                              <span>This offer is no longer available.</span>
                            </div>
                          </div>
                        </div>
                      )}

                    {selectedTab === 0 ? (
                      <>
                        {isSubmitting && <LoadingSpinner />}
                        <div className='driver-booking-card'>
                          <div
                            class='card-top-indicator'
                            style={
                              list.greeter && tokenUser && !tokenUser.isPartner
                                ? list.status ===
                                    'cancellation_accepted_by_agent' ||
                                  list.status === 'cancelled_by_agent'
                                  ? { backgroundColor: '#d0021b' }
                                  : list.status === 'completed'
                                  ? { backgroundColor: 'black' }
                                  : list.vipDispatchStatus === 'completed'
                                  ? { backgroundColor: 'black' }
                                  : {}
                                : list.supplierInfo && list.supplierInfo.status
                                ? list.status ===
                                    'cancellation_accepted_by_agent' ||
                                  list.status === 'cancelled_by_agent'
                                  ? { backgroundColor: '#d0021b' }
                                  : list.status === 'completed'
                                  ? { backgroundColor: 'black' }
                                  : list.vipDispatchStatus === 'completed'
                                  ? { backgroundColor: 'black' }
                                  : list.supplierInfo.status === 'accepted'
                                  ? { backgroundColor: '#417505' }
                                  : list.isOperativeBranch &&
                                    list.vipDispatchStatus === 'accepted'
                                  ? { backgroundColor: '#417505' }
                                  : list.isOperativeBranch &&
                                    list.vipDispatchStatus === 'outsourced'
                                  ? { backgroundColor: '#1e2b8e' }
                                  : list.supplierInfo.status === 'dispatched' ||
                                    list.supplierInfo.status === 'opened'
                                  ? {
                                      backgroundColor: 'rgb(245, 166, 35)',
                                    }
                                  : list.supplierInfo.status === 'expired' ||
                                    list.supplierInfo.status === 'declined'
                                  ? { backgroundColor: '#d0021b' }
                                  : {}
                                : {}
                            }
                          ></div>
                          <div className='driver-booking-header'>
                            <div className='driver-title-partner'>
                              <span>#{list.number}</span>
                              {isMobileBrowser ? (
                                <span style={{ fontWeight: '900' }}>
                                  {vipLegWord}
                                </span>
                              ) : (
                                <span style={{ fontWeight: '900' }}>
                                  {vipLegFull}
                                </span>
                              )}
                              {/* <span style={{ fontWeight: '900' }}>
                                VIP Meet & Greet
                              </span> */}
                              {tokenUser &&
                              !tokenUser.isPartner &&
                              list.greeter ? (
                                <Badge
                                  href='#'
                                  variant={
                                    list.status ===
                                      'cancellation_accepted_by_agent' ||
                                    list.status === 'cancelled_by_agent'
                                      ? `cancelled-dispatch badge-outlined mt-1 ml-3`
                                      : list.status === 'completed'
                                      ? 'completed-dispatch badge-outlined mt-1 ml-3'
                                      : list.vipDispatchStatus === 'completed'
                                      ? 'completed-dispatch badge-outlined mt-1 ml-3'
                                      : !list.isDriverAndNotAccepted
                                      ? `accepted-dispatch badge-outlined mt-1 ml-3`
                                      : list.isOperativeBranch &&
                                        list.vipDispatchStatus ===
                                          'outsourced' &&
                                        list.outsourcedSuppliers
                                      ? 'outsourced-dispatch badge-outlined'
                                      : list.isOperativeBranch &&
                                        list.vipDispatchStatus === 'accepted'
                                      ? `accepted-dispatch badge-outlined mt-1 ml-3`
                                      : `new-booking badge-outlined mt-1 ml-3`
                                  }
                                  style={{
                                    display: 'flex',
                                    alignSelf: 'baseline',
                                  }}
                                >
                                  {list.status ===
                                    'cancellation_accepted_by_agent' ||
                                  list.status === 'cancelled_by_agent'
                                    ? 'CANCELLED'
                                    : list.status === 'completed'
                                    ? 'COMPLETED'
                                    : list.vipDispatchStatus === 'completed'
                                    ? 'COMPLETED'
                                    : !list.isDriverAndNotAccepted
                                    ? 'ACCEPTED'
                                    : isLocalSupplier &&
                                      list.vipDispatchStatus === 'outsourced' &&
                                      list.outsourcedSuppliers
                                    ? 'OUTSOURCED'
                                    : list.isOperativeBranch &&
                                      list.vipDispatchStatus === 'accepted'
                                    ? `ACCEPTED`
                                    : 'PENDING'}
                                </Badge>
                              ) : (
                                [
                                  list.supplierInfo &&
                                    list.supplierInfo.status && (
                                      <Badge
                                        href='#'
                                        variant={
                                          list.vipDispatchStatus === 'accepted'
                                            ? `accepted-dispatch badge-outlined mt-1 ml-3`
                                            : list.vipDispatchStatus ===
                                              'completed'
                                            ? 'completed-dispatch badge-outlined mt-1 ml-3'
                                            : list.supplierInfo.status ===
                                                'dispatched' ||
                                              list.supplierInfo.status ===
                                                'opened'
                                            ? `new-booking badge-outlined mt-1 ml-3`
                                            : list.supplierInfo.status ===
                                                'expired' ||
                                              list.supplierInfo.status ===
                                                'declined'
                                            ? `expired-dispatch badge-outlined mt-1 ml-3`
                                            : ``
                                        }
                                        style={{
                                          display: 'flex',
                                          alignSelf: 'baseline',
                                        }}
                                      >
                                        {list.vipDispatchStatus === 'accepted'
                                          ? 'ACCEPTED'
                                          : list.vipDispatchStatus ===
                                            'completed'
                                          ? 'COMPLETED'
                                          : list.supplierInfo.status ===
                                              'dispatched' ||
                                            list.supplierInfo.status ===
                                              'opened'
                                          ? 'PENDING'
                                          : list.supplierInfo.status ===
                                            'expired'
                                          ? `EXPIRED`
                                          : list.supplierInfo.status ===
                                            'declined'
                                          ? 'DECLINED'
                                          : ``}
                                      </Badge>
                                    ),
                                ]
                              )}
                            </div>
                          </div>
                          <div
                            className='driver-booking-body'
                            style={
                              list.vipG &&
                              ((tokenUser &&
                                tokenUser.isDriver &&
                                !list.vipDispatch) ||
                                (tokenUser &&
                                  tokenUser.isDriver &&
                                  !tokenUser.isPartner &&
                                  list.vipDispatch))
                                ? {
                                    padding: '1em 1em 2em 1em',
                                    border:
                                      '1.5px solid rgba(139, 149, 158, 0.2)',
                                    borderBottomRightRadius: '10px',
                                    borderBottomLeftRadius: '10px',
                                  }
                                : {
                                    padding: '1em 1em 2em 1em',
                                    border:
                                      '1.5px solid rgba(139, 149, 158, 0.2)',
                                    borderBottomRightRadius: '10px',
                                    borderBottomLeftRadius: '10px',
                                  }
                            }
                          >
                            <div className='driver-content'>
                              <>
                                {list.supplierInfo &&
                                  list.supplierInfo.status === 'accepted' && (
                                    <>
                                      {list.passengerInfo ? (
                                        <div className='passenger-name'>
                                          {list.passengerInfo.title}{' '}
                                          {list.passengerInfo.lastName}
                                          <span>
                                            {list.passengerInfo.isVip && (
                                              <img
                                                style={{
                                                  marginLeft: '10px',
                                                  width: '24px',
                                                  height: '20px',
                                                }}
                                                src='/images/icons/icon-vip.png'
                                                alt=''
                                              />
                                            )}
                                          </span>
                                        </div>
                                      ) : list.driversInfo ? (
                                        <div className='passenger-name'>
                                          {list.driversInfo[0].title}{' '}
                                          {list.driversInfo[0].lastName}
                                          <span>
                                            {list.driversInfo[0] &&
                                              list.driversInfo[0].isVip && (
                                                <img
                                                  style={{
                                                    marginLeft: '10px',
                                                    width: '24px',
                                                    height: '20px',
                                                  }}
                                                  src='/images/icons/icon-vip.png'
                                                  alt=''
                                                />
                                              )}
                                          </span>
                                        </div>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  )}
                                <div className='passenger-details'>
                                  <img src='/images/icons/team.svg' />
                                  <span>
                                    {list.passengerInfo &&
                                      (list.passengerInfo.passenger === 0
                                        ? 0
                                        : list.passengerInfo.passenger)}
                                  </span>
                                  <img
                                    src='/images/icons/portfolio.svg'
                                    style={{
                                      marginLeft: '10px',
                                      width: '6.5% important',
                                    }}
                                    alt=''
                                  />
                                  <span>
                                    {list.passengerInfo &&
                                      (list.passengerInfo.luggage === 0
                                        ? 0
                                        : list.passengerInfo.luggage)}
                                  </span>
                                </div>
                              </>

                              {(list.durationType !== 'daily' ||
                                !list.days) && (
                                <div className='date'>
                                  <img src='/images/icon_calendar.png' alt='' />
                                  <span>
                                    {`
              ${moment.utc(list.pickUpDate).format(dateFormatDetailed)},
              ${moment.utc(list.pickUpDate).format('HH:mm')}
            `}
                                  </span>
                                </div>
                              )}
                              <div className='airport'>
                                <img src='/images/icons/Airport.png' />
                                <span>
                                  {list.meetAndAssist?.arrival
                                    ? list.meetAndAssist?.arrival?.iata_code
                                    : list.meetAndAssist?.departure?.iata_code}
                                </span>
                              </div>
                              <div className='flight'>
                                <img
                                  src={
                                    isStandaloneVip
                                      ? standaloneFirstFlightIcon
                                      : '/images/icons/Icon_Airport_Partner.png'
                                  }
                                />
                                <span>
                                  {list?.airportPickUpInfo
                                    ? list?.airportPickUpInfo?.flightNumber?.toUpperCase()
                                    : list?.airportDropOffInfo?.flightNumber?.toUpperCase()}
                                </span>
                              </div>
                              {/* Standalone VIP transit: 2nd flight (departure) on the mobile card (QA 29). */}
                              {transitDepartureFlightNumber && (
                                <div className='flight'>
                                  <img src='/images/icons/icon-flight-vipmg-departure.svg' />
                                  <span>
                                    {transitDepartureFlightNumber.toUpperCase()}
                                  </span>
                                </div>
                              )}
                              {/* Standalone VIP accepts via dispatchStatus (changesSupplierAccepted),
                                  not supplierInfo.status — so the legacy gate hid the name-board CTA
                                  on mobile (QA 22). mobileNameboardVisible (hoisted to the component
                                  body) allows it for standalone VIP accepted with a flight. */}
                              {mobileNameboardVisible && (
                                <div className='nameboard'>
                                  <img
                                    src={
                                      isStandaloneVip
                                        ? '/images/icons/icon-nameboard-vipmg.svg'
                                        : '/images/icon-nameboard.png'
                                    }
                                  />
                                  <span
                                    onClick={() => {
                                      getNameboard()
                                    }}
                                  >
                                    Get PDF name-board
                                  </span>
                                </div>
                              )}
                              {isStandaloneVip && changesSupplierAccepted && (
                                <div
                                  className='d-flex align-items-start mt-2'
                                  style={{ gap: '8px' }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      width: '22px',
                                      height: '24px',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      flexShrink: 0,
                                    }}
                                  >
                                    <svg
                                      width='11'
                                      height='11'
                                      viewBox='0 0 11 11'
                                      fill='none'
                                      xmlns='http://www.w3.org/2000/svg'
                                      xmlnsXlink='http://www.w3.org/1999/xlink'
                                    >
                                      <rect
                                        width='11'
                                        height='11'
                                        fill='url(#pickup_icon_mobile_sv)'
                                      />
                                      <defs>
                                        <pattern
                                          id='pickup_icon_mobile_sv'
                                          patternContentUnits='objectBoundingBox'
                                          width='1'
                                          height='1'
                                        >
                                          <use
                                            xlinkHref='#pickup_img_mobile_sv'
                                            transform='scale(0.0166667)'
                                          />
                                        </pattern>
                                        <image
                                          id='pickup_img_mobile_sv'
                                          width='60'
                                          height='60'
                                          preserveAspectRatio='none'
                                          xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAABVZJREFUaEPlW01sG0UUfm8dYy/e2TjCiam5IDWiQoITB0AqTXPhRyqqQCCUcig3JMQBSEECKf1JEQdIgANC4kYPNEIgUEUl4EKhrQQcegIJgYLKBYMToyQ7a7xOvPvQi9aR6yTeGduJI3akPc2b9963M/v+5i3CDo1CoXBzpVI5GATBPQBwIHxuBQBBRILFIqIEAH7+BoBf+TEM41omk7laLBb/3QnVsJdM8/n8SLVaPUZEjxPRvQBwU4f8VxHxR0T8zDTN86VSaaFDPpuW9QSwZVmHEPFlInoYAAZ6pVzIp46IXxHRW67rXu6Wd1eAs9nsuO/700R0sFtFVNYj4tVEIjG1vLz8rQr9VjQdAc7lcvs8z5sFgIlOBXe5bi6dTk+Wy+W/dPloA7Zt+xEimiOiQV1hvaRHxBVEnHAc50sdvlqAhRCTRPQmABg6QnaQNkDEV6SUfNqUhhLg0dHRVKlU+oCIjitx3WUiRDyXz+efnZ+fr0WJjgRsWdYwIl4govujmPVzHhG/J6KjrusuttOjLeBwZy/tdbANgAw6n8+Pt9vptoCFEB92e4wR8XcAuICI1wzDKPq+X0ylUuvWtVar7UskEoUgCApExBHZUSLa381J4eMtpXxmOx7bAg4N1EyHwjkyei+ZTH6+tLT0sw6PoaGhu9bW1h4DgOcBYERnbdNOn9jOkG0JmF1PEAQXda0xIrqIOJtKpWYWFxfdTpRtrBkeHrZqtdoJImLPYGnyCgzDOLKVy9oEmIOKWq32i66fDePe5xYWFkqayrUlHxkZyVer1fc5Ptfhy346lUrd2RqcbAJsWdZ5zQiKDMOYXllZOYOIpKOUKi0R4eDg4KkgCE5ykqW6DgDmXNc91kx/w2KOjev1+jcaDKsAcNx13U801nRMalnWkwBwDgBMVSYDAwPjzbH3DYCFEFc0EgHezad2C2wDYAj6Y9Wd5oRDSvnAhkFrYjQGAMpZiGEYZxzHOa36pntJZ9v26SAITmnwPOy67ndMv7HDQogviOiIChM2UI7jPLFT32yUDvxN27b9qaohQ8SLUspHNwBzpaJSqfypkryz6zFNc7TX1jgKZOt8aL3nFV1WPZPJ3MaVk/Udtm37hSAI3lER2s+j3KqfztE2DONFx3HeXQcshLhMRBsfdhvgC6Zp7u82qFB5sSo0HJxUq1UOXSMjMkS8IqU8hFxddBxnSbHgNuW67usqyuwWjWVZUwAwrSBv1bbtIXboD/q+/7XCAkgmk3frxsYqfLuhCWPvn1R4JBKJh1AI8SoRvRG1gLMeKeVoFF0/5oUQbLwisyxEfI0BK6WAiPi2lHKyH4CiZAohZonopSg6Th0ZMFcK7osiNgzjacdxOM7ec8O27WNBEHwUpRgi/sCArxPR7VHErTFpFP1uzmez2cP1ev1SlExE/IMBl4noFgXiA1LK36Lo+jEvhLiDiPhuqu1AxH/Qsiyu9EXeAZmmKfaK/21FFfpjvpSLGqvKgNPptF0ul1WYRgnt+XwulxOe5zkKjFfjd6TjaLRi55ZiF3jEK7SMXfKgmR6edF33rIL53zUS7fSQNYtVAYABx67EE7siXnis41OmZcDcawUA68VqldHP6qVOtTLEMtbo8YrvVQu/idhdpoVHOz7XpQw4dhfioV+OT8tDw0LHqqmlCbRS6tjOjW3VtpROp4u8xvO8wp5pW2KFYteYFlrt+LQeNo5qrJpLm7/P2LQPN4OOVYN4A3isfgFo3m2+xPJ9/6xGb5dKIrYtTd9+8mjVyLKsMUTkRtCd/I1nptFr1c1b0+lbjJTDrUSe503873/U2upN7NVf8f4DbFWNFsogag4AAAAASUVORK5CYII='
                                        />
                                      </defs>
                                    </svg>
                                  </div>
                                  <p
                                    style={{
                                      color: '#000',
                                      fontFamily: '"Avenir Next"',
                                      fontSize: '16px',
                                      fontStyle: 'normal',
                                      fontWeight: 400,
                                      lineHeight: '150%',
                                      margin: 0,
                                    }}
                                  >
                                    Please meet the passenger(s) in{' '}
                                    {isArrival || isTransit
                                      ? 'Arrivals'
                                      : 'Departures'}{' '}
                                    with the name-board:{' '}
                                    {list.airportPickUpInfo
                                      ? list.airportPickUpInfo.pickUpSign
                                      : list.passengerInfo
                                      ? list.passengerInfo.lastName
                                      : list.driversInfo
                                      ? list.driversInfo[0].lastName
                                      : ''}
                                    .
                                    {(isArrival || isTransit
                                      ? list.meetAndAssist?.arrival?.iata_code
                                      : list.meetAndAssist?.departure
                                          ?.iata_code) && (
                                      <>
                                        {' '}
                                        (
                                        {isArrival || isTransit
                                          ? list.meetAndAssist?.arrival
                                              ?.iata_code
                                          : list.meetAndAssist?.departure
                                              ?.iata_code}
                                        )
                                      </>
                                    )}
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>

                          {showDispatchedDriverCard ? (
                            <>
                              {assignedChauffeur ? (
                                <div
                                  style={{ marginBottom: '1em' }}
                                  className='driver-service-card'
                                >
                                  <div
                                    className='driver-service-card-header'
                                    style={{ fontSize: '15px' }}
                                  >
                                    Chauffeur
                                  </div>
                                  <div className='driver-service-card-body'>
                                    <div className='driver-service-card-item'>
                                      <span>Chauffeur's name</span>
                                      <span>{assignedChauffeur.fullName}</span>
                                    </div>
                                    <div className='driver-service-card-item'>
                                      <span>Phone number</span>
                                      <span>{assignedChauffeur.phone}</span>
                                    </div>
                                    <div className='driver-service-card-item'>
                                      <span>Vehicle</span>
                                      <span>{assignedChauffeurVehicle}</span>
                                    </div>
                                    <div className='driver-service-card-item'>
                                      <span>Plate number</span>
                                      <span>{assignedChauffeur.plateNo}</span>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div
                                  style={{ marginBottom: '1em' }}
                                  className='driver-service-card'
                                >
                                  <div
                                    className='driver-service-card-header'
                                    style={{ fontSize: '15px' }}
                                  >
                                    <span>Chauffeur</span>
                                  </div>
                                  <p
                                    className='mt-3'
                                    style={{ fontSize: '15px' }}
                                  >
                                    This booking includes{' '}
                                    {getLabelFromValue(
                                      defaultBookingServicePartner,
                                      list.bookingType || list.type
                                    )}{' '}
                                    service. The chauffeur's name and phone
                                    number will be shared once assigned.
                                  </p>
                                </div>
                              )}
                            </>
                          ) : (
                            <></>
                          )}

                          {list.vipDispatchStatus === 'accepted' && (
                            <>
                              {!isStandaloneVip &&
                                (addonPassengers.length > 0 ? (
                                  renderVipPartnerPassengerCards(
                                    addonPassengers,
                                    list,
                                    downloadVipFile
                                  )
                                ) : (
                                  <div className='driver-service-card'>
                                    <div
                                      className='driver-service-card-header'
                                      style={{ fontSize: '15px' }}
                                    >
                                      Passenger
                                    </div>
                                    <div className='driver-service-card-body'>
                                      <div className='driver-service-card-item'>
                                        <span>Guest name</span>
                                        <span>
                                          {list.passengerInfo
                                            ? list.passengerInfo.fullName
                                            : list.driversInfo
                                            ? list.driversInfo[0].fullName
                                            : ''}
                                        </span>
                                      </div>
                                      <div className='driver-service-card-item'>
                                        <span>Phone number</span>
                                        <span>
                                          {list.passengerInfo
                                            ? list.passengerInfo.phone
                                            : list.driversInfo
                                            ? list.driversInfo[0].phone
                                            : ''}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                ))}

                              {assignedChauffeur ? (
                                <div className='driver-service-card'>
                                  <div
                                    className='driver-service-card-header'
                                    style={{ fontSize: '15px' }}
                                  >
                                    Chauffeur
                                  </div>
                                  <div className='driver-service-card-body'>
                                    <div className='driver-service-card-item'>
                                      <span>Chauffeur's name</span>
                                      <span>{assignedChauffeur.fullName}</span>
                                    </div>
                                    <div className='driver-service-card-item'>
                                      <span>Phone number</span>
                                      <span>{assignedChauffeur.phone}</span>
                                    </div>
                                    <div className='driver-service-card-item'>
                                      <span>Vehicle</span>
                                      <span>{assignedChauffeurVehicle}</span>
                                    </div>
                                    <div className='driver-service-card-item'>
                                      <span>Plate number</span>
                                      <span>{assignedChauffeur.plateNo}</span>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <>
                                  {!isStandaloneVip && (
                                    <div className='driver-service-card'>
                                      <div
                                        className='driver-service-card-header'
                                        style={{ fontSize: '15px' }}
                                      >
                                        <span>Chauffeur</span>
                                      </div>
                                      <p
                                        className='mt-3'
                                        style={{ fontSize: '15px' }}
                                      >
                                        This booking includes{' '}
                                        {getLabelFromValue(
                                          defaultBookingServicePartner,
                                          list.bookingType || list.type
                                        )}{' '}
                                        service. The chauffeur's name and phone
                                        number will be shared once assigned.
                                      </p>
                                    </div>
                                  )}
                                </>
                              )}

                              {isStandaloneVip &&
                                standalonePassengers.length > 0 &&
                                renderVipPartnerPassengerCards(
                                  standalonePassengers,
                                  list,
                                  downloadVipFile
                                )}

                              {/* Legacy (non-standalone) VIP pick-up instructions — standalone
                                  VIP has its own inline block above, so exclude here (QA 4992-Z). */}
                              {!isStandaloneVip && (
                                <div className='driver-service-card'>
                                  <div
                                    className='driver-service-card-header'
                                    style={{ fontSize: '15px' }}
                                  >
                                    <span>Pick-up instructions</span>
                                  </div>
                                  <p
                                    className='mt-3'
                                    style={{ fontSize: '15px' }}
                                  >
                                    Please meet the passenger(s) in{' '}
                                    {isArrival ? 'Arrivals' : 'Departures'} with
                                    the name-board:{' '}
                                    {list.airportPickUpInfo
                                      ? list.airportPickUpInfo.pickUpSign
                                      : list.passengerInfo
                                      ? list.passengerInfo.lastName
                                      : list.driversInfo
                                      ? list.driversInfo[0].lastName
                                      : ''}{' '}
                                  </p>
                                  {list.supplierInfo &&
                                    list.supplierInfo.status === 'accepted' &&
                                    ((list.airportPickUpInfo &&
                                      list.airportPickUpInfo.flightType ===
                                        'commercial') ||
                                      list.trainPickUpInfo ||
                                      (list.shipPickUpInfo &&
                                        list.shipPickUpInfo.shipType ===
                                          'cruise')) && (
                                      <div className='name-board'>
                                        <Button
                                          className='partner-btn-desktop-secondary select-vehicle'
                                          variant='brown'
                                          onClick={() => {
                                            generatePdf()
                                          }}
                                        >
                                          Get PDF name-board
                                        </Button>
                                      </div>
                                    )}
                                </div>
                              )}
                            </>
                          )}

                          {isStandaloneVip &&
                            !isStandaloneAccepted &&
                            standalonePassengers.length > 0 &&
                            renderVipPartnerPassengerCards(
                              standalonePassengers,
                              list,
                              downloadVipFile,
                              {
                                showName: false,
                                showPhone: false,
                                showDocuments: false,
                              }
                            )}

                          {tokenUser && tokenUser.isPartner && (
                            <div
                              style={{ marginBottom: '1em' }}
                              className='driver-service-card'
                            >
                              <div className='driver-service-card-header'>
                                <span>Terms</span>
                              </div>

                              <div className='driver-service-card-body'>
                                <div className='driver-service-card-item'>
                                  <span>
                                    <span>Free cancellation</span>{' '}
                                    <TooltipOnHover
                                      delay={200}
                                      placement='right-start'
                                      isMobileBrowser={isMobileBrowser}
                                      onMouseEnter={() => {}}
                                      component={
                                        <div>
                                          If an accepted booking gets cancelled
                                          before the booking commences, the
                                          client shall receive a cancellation
                                          refund if applicable.
                                        </div>
                                      }
                                    >
                                      <img
                                        className={'new-info-icon'}
                                        style={{
                                          marginLeft: '0.5rem',
                                          marginTop: '0.156rem',
                                          height: '0.938rem',
                                        }}
                                        src='/images/icons/new-info-icon.png'
                                        alt=''
                                      />
                                    </TooltipOnHover>
                                  </span>
                                  <span>
                                    {
                                      resolveCancellationPolicy(list)
                                        ?.cancellation
                                    }{' '}
                                    before pick-up
                                  </span>
                                </div>
                                {isStandaloneVip
                                  ? showHoursIncluded && (
                                      <div className='driver-service-card-item'>
                                        <span>Hours included</span>
                                        <span>
                                          {list.vipRate?.hoursIncluded ?? 3}{' '}
                                          hours
                                        </span>
                                      </div>
                                    )
                                  : renderAddonHoursIncludedRow(
                                      list,
                                      isArrival
                                    )}
                              </div>
                            </div>
                          )}

                          {list.supplierInfo ? (
                            <>
                              {list.supplierInfo.buyingPrice &&
                              isMobileBrowser ? (
                                <>
                                  <div
                                    className='driver-service-card mt-0'
                                    // style={{
                                    //   borderTopLeftRadius: '0px',
                                    //   borderTopRightRadius: '0px',
                                    // }}
                                  >
                                    <PartnerPricingDetails
                                      serviceType={vipLegFull}
                                      supplierInfo={list.supplierInfo}
                                      dispatch={list.vipDispatch}
                                      charges={list.partnerCharges}
                                      bookingId={bookingId}
                                      bookingPartner={list.vipDispatch}
                                      reloadList={reloadList}
                                      isLocalSupplier={list.isOperativeBranch}
                                      vipDispatchStatus={list.vipDispatchStatus}
                                    />
                                  </div>
                                </>
                              ) : (
                                <div className='driver-booking-price'>
                                  {numberWithCommas(
                                    getFormattedPrice(
                                      list.supplierInfo.buyingPrice
                                    )
                                  )}{' '}
                                  {getLabelFromValue(
                                    defaultCurrencies,
                                    list.supplierInfo.supplierCurrency
                                  )}
                                </div>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                        {list.serviceNotes && list.serviceNotes !== '' ? (
                          <div className='driver-service-card'>
                            <div className='driver-service-card-header'>
                              <span>Notes</span>
                            </div>
                            <p className='mt-3'>{list.serviceNotes}</p>
                          </div>
                        ) : (
                          <></>
                        )}

                        {list.addInfo !== '' && list.isOperativeBranch ? (
                          <>
                            <div className='driver-service-card'>
                              <div className='driver-service-card-header'>
                                <span>Client notes</span>
                              </div>
                              <p className='mt-3'>{list.addInfo}</p>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}

                        {list.seatInfo &&
                          (list.seatInfo.babySeat ||
                            list.seatInfo.childSeat ||
                            list.seatInfo.boosterSeat) && (
                            <div className='driver-service-card'>
                              <div
                                className='driver-service-card-header'
                                style={{
                                  fontSize: '16px',
                                  marginBottom: '20px',
                                }}
                              >
                                Child seat
                              </div>
                              {list.seatInfo.babySeat ? (
                                <>
                                  <div className='driver-service-card-item-seat'>
                                    <img src='/images/icons/baby_seat.png' />
                                    <div className='driver-service-card-item-with-desc-mob'>
                                      <span>
                                        Baby seat x {list.seatInfo.babySeat}
                                      </span>
                                      <span>Age: Up to 1 year old</span>
                                      <span>Weight: Under 9 kg/20 lbs</span>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                              {list.seatInfo.childSeat ? (
                                <>
                                  <div className='driver-service-card-item-seat'>
                                    <img src='/images/icons/child_seat.png' />
                                    <div className='driver-service-card-item-with-desc-mob'>
                                      <span>
                                        Child seat x {list.seatInfo.childSeat}
                                      </span>
                                      <span>Age: 1-3 years old</span>
                                      <span>Weight: 9-18 kg/20-40 lbs</span>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                              {list.seatInfo.boosterSeat ? (
                                <>
                                  <div className='driver-service-card-item-seat'>
                                    <img src='/images/icons/booster_seat.png' />
                                    <div className='driver-service-card-item-with-desc-mob'>
                                      <span>
                                        Booster seat x{' '}
                                        {list.seatInfo.boosterSeat}
                                      </span>
                                      <span>Age: 3-11 years old</span>
                                      <span>Weight: 18-45 kg/ 40-100 lbs</span>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                          )}

                        <Modal
                          show={showPdf}
                          onHide={() => setShowPdf(false)}
                          dialogClassName='modal-90w modal-padding'
                          size='lg'
                          aria-labelledby='contained-modal-title-vcenter'
                          centered
                        >
                          <Modal.Body>
                            <embed
                              src={pdfLink}
                              type='application/pdf'
                              height='100%'
                              width='100%'
                            ></embed>
                          </Modal.Body>
                        </Modal>
                      </>
                    ) : selectedTab === 1 ? (
                      <>
                        {/* {list.driver &&
                          (!list.supplierInfo ||
                            (list.supplierInfo &&
                              list.supplierInfo.status !== 'expired')) &&
                          list.status !== 'cancellation_accepted_by_agent' &&
                          list.status !== 'cancelled_by_agent' &&
                          !list.isDriverAndNotAccepted &&
                          !updateDayCompleted && (
                            <div className='driver-info-layout-mobile'>
                              {isSubmitting && <LoadingSpinner />}
                              <div className='driver-info-column'>
                                {list.durationType === 'daily' &&
                                  list.days &&
                                  updateOnSite &&
                                  updateContactMade &&
                                  updateServiceComplete &&
                                  currentDay !== list.days.length && (
                                    <div className='partner-banner mt-4'>
                                      <div className='imageContainer'>
                                        <img
                                          src='/images/icons/icon-warning.png'
                                          alt=''
                                        />
                                      </div>
                                      <div className='partnerContainer'>
                                        <span>
                                          Please mark the day as completed.
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                <div
                                  className='driver-service-card'
                                  style={{
                                    border: 'none',
                                    background: 'none',
                                    padding: '0.5em 0.5em 5.5em 0.5em',
                                  }}
                                >
                                  {list.durationType === 'daily' && list.days && (
                                    <p>
                                      Day {currentDay} (
                                      {moment
                                        .utc(
                                          list.days[currentDay - 1].pickUpDate
                                        )
                                        .format(dateFormatDetailed)}
                                      )
                                    </p>
                                  )}
                                  <div className='driver-service-card-body-container'>
                                    <div class='step'>
                                      <div class='v-stepper'>
                                        <div
                                          class={
                                            updateOnSite
                                              ? 'update-circle-filled'
                                              : 'update-circle'
                                          }
                                        />
                                        <div
                                          className={
                                            updateOnSite
                                              ? 'vertical-filled'
                                              : 'vertical-dashed'
                                          }
                                        ></div>
                                      </div>
                                      <div className='driver-service-card-container'>
                                        <div
                                          className={
                                            updateOnSite
                                              ? 'driver-service-card-item-updates updates-complete indicator-black'
                                              : bookingInTwoHours
                                              ? 'driver-service-card-item-updates indicator-red'
                                              : 'driver-service-card-item-updates'
                                          }
                                        >
                                          <span>1</span>
                                          <span
                                            style={
                                              bookingInTwoHours && !updateOnSite
                                                ? { color: '#d0021b' }
                                                : {}
                                            }
                                          >
                                            {listExists &&
                                            !list.chauffeurOfBooking &&
                                            list.partnerOfBooking ? (
                                              <>
                                                {bookingInTwoHours &&
                                                !updateOnSite
                                                  ? `Is ${
                                                      list.driver.fullName.split(
                                                        ' '
                                                      )[0]
                                                    } is on the way?`
                                                  : `${
                                                      list.driver.fullName.split(
                                                        ' '
                                                      )[0]
                                                    } is on the way`}
                                              </>
                                            ) : (
                                              <>
                                                {bookingInTwoHours &&
                                                !updateOnSite
                                                  ? `Are you on the way?`
                                                  : `You are on the way`}
                                              </>
                                            )}
                                          </span>
                                          <span
                                            style={
                                              bookingInTwoHours && !updateOnSite
                                                ? { color: '#d0021b' }
                                                : {}
                                            }
                                          >
                                            {!checkBookingAfterADay(
                                              list.pickUpDate
                                            ) &&
                                              !updateOnSite &&
                                              bookingTimeLeft}
                                          </span>
                                          {updateOnSite && (
                                            <img
                                              alt=''
                                              style={{
                                                marginLeft: '10px',
                                                alignSelf: 'center',
                                              }}
                                              width={20}
                                              src='/images/icons/icon-checklist-black.png'
                                            ></img>
                                          )}
                                        </div>
                                        {updateOnSite && updateOnSite.time && (
                                          <span className='status-update-timestamp'>
                                            {moment
                                              .utc(updateOnSite.time)
                                              .format(newTimeFormat)}
                                          </span>
                                        )}
                                      </div>
                                    </div>

                                    <div class='step'>
                                      <div class='v-stepper'>
                                        <div
                                          class={
                                            updateContactMade
                                              ? 'update-circle-filled'
                                              : 'update-circle'
                                          }
                                        />
                                        <div
                                          className={
                                            updateContactMade
                                              ? 'vertical-filled'
                                              : 'vertical-dashed'
                                          }
                                        ></div>
                                      </div>
                                      <div className='driver-service-card-container'>
                                        <div
                                          className={`driver-service-card-item-updates 
                               
                                `}
                                        >
                                          <span> 2 </span>
                                          <span
                                            style={
                                              updateOnSite && !updateContactMade
                                                ? { color: '#d0021b' }
                                                : {}
                                            }
                                          >
                                            {listExists &&
                                            !list.chauffeurOfBooking &&
                                            list.partnerOfBooking ? (
                                              <>
                                                {' '}
                                                {updateOnSite &&
                                                !updateContactMade
                                                  ? `Has ${
                                                      list.driver.fullName.split(
                                                        ' '
                                                      )[0]
                                                    } arrived?`
                                                  : `${
                                                      list.driver.fullName.split(
                                                        ' '
                                                      )[0]
                                                    } has arrived`}
                                              </>
                                            ) : (
                                              <>
                                                {updateOnSite &&
                                                !updateContactMade
                                                  ? `Have you arrived?`
                                                  : `You have arrived`}
                                              </>
                                            )}
                                          </span>
                                          <span
                                            style={
                                              bookingInTwoHours &&
                                              !updateContactMade
                                                ? { color: '#d0021b' }
                                                : {}
                                            }
                                          >
                                            {!checkBookingAfterADay(
                                              list.pickUpDate
                                            ) &&
                                              !updateContactMade &&
                                              updateOnSite &&
                                              bookingTimeLeft}{' '}
                                          </span>
                                          {updateContactMade && (
                                            <img
                                              style={{
                                                marginLeft: '10px',
                                                alignSelf: 'center',
                                              }}
                                              width={20}
                                              src='/images/icons/icon-checklist-black.png'
                                              alt=''
                                            ></img>
                                          )}
                                        </div>
                                        {updateContactMade &&
                                          updateContactMade.time && (
                                            <span className='status-update-timestamp'>
                                              {moment
                                                .utc(updateContactMade.time)
                                                .format(newTimeFormat)}
                                            </span>
                                          )}
                                      </div>
                                    </div>

                                    <div class='step'>
                                      <div class='v-stepper'>
                                        <div
                                          class={
                                            updateServiceComplete
                                              ? 'update-circle-filled'
                                              : 'update-circle'
                                          }
                                        ></div>
                                        <div
                                          className={
                                            updateServiceComplete
                                              ? 'vertical-filled'
                                              : 'vertical-dashed'
                                          }
                                        ></div>
                                      </div>
                                      <div className='driver-service-card-container'>
                                        <div
                                          className={`driver-service-card-item-updates 
                             
                              `}
                                        >
                                          <span> 3 </span>
                                          <span
                                            style={
                                              updateOnSite &&
                                              updateContactMade &&
                                              !updateServiceComplete
                                                ? { color: '#d0021b' }
                                                : {}
                                            }
                                          >
                                            {updateOnSite &&
                                            updateContactMade &&
                                            !updateServiceComplete
                                              ? 'Is the passenger on board?'
                                              : 'The passenger is on board'}
                                          </span>
                                          {updateServiceComplete && (
                                            <img
                                              style={{
                                                marginLeft: '17px',
                                                alignSelf: 'center',
                                              }}
                                              width={20}
                                              src='/images/icons/icon-checklist-black.png'
                                              alt=''
                                            ></img>
                                          )}
                                        </div>
                                        {updateServiceComplete &&
                                          updateServiceComplete.time && (
                                            <span className='status-update-timestamp'>
                                              {moment
                                                .utc(updateServiceComplete.time)
                                                .format(newTimeFormat)}
                                            </span>
                                          )}
                                      </div>
                                    </div>

                                    <div class='step'>
                                      <div class='v-stepper'>
                                        <div
                                          class={
                                            updateServiceComplete
                                              ? 'update-circle-filled'
                                              : 'update-circle'
                                          }
                                        ></div>
                                      </div>
                                      <div className='driver-service-card-container'>
                                        <div
                                          className={`driver-service-card-item-updates 
                              `}
                                        >
                                          <span
                                            style={
                                              updateOnSite &&
                                              updateContactMade &&
                                              updateServiceComplete
                                                ? { color: '#d0021b' }
                                                : {}
                                            }
                                          >
                                            {updateOnSite &&
                                            updateContactMade &&
                                            updateServiceComplete
                                              ? list.dropOffLocation
                                                ? `Was the passenger dropped off?`
                                                : `Was the passenger dropped off?`
                                              : list.dropOffLocation
                                              ? `The passenger was dropped off`
                                              : `The passenger was dropped off`}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <ConfirmationModal
                                onHide={() => {
                                  setShowConfirmationModal(false)
                                  setSubmitting(false)
                                }}
                                handleFunction={onConfirmationModal}
                                show={showConfirmationModal}
                                confirmationText={displayAlertText}
                                confirmationTitle={displayAlertTitle}
                                changeConfirmationTitle={true}
                                driver={true}
                              />
                            </div>
                          )} */}
                      </>
                    ) : (
                      <></>
                    )}

                    {selectedTab === 1 &&
                      list.greeter &&
                      (!list.supplierInfo ||
                        (list.supplierInfo &&
                          list.supplierInfo.status !== 'expired' &&
                          list.supplierInfo.status !== 'declined' &&
                          list.supplierInfo.status !== 'declined changes')) &&
                      list.status !== 'cancellation_accepted_by_agent' &&
                      list.status !== 'cancelled_by_agent' &&
                      !list.isDriverAndNotAccepted && (
                        <>
                          <div className='driver-info-layout-mobile'>
                            <div className='driver-info-column'>
                              <div
                                className='driver-service-card'
                                style={{
                                  border: 'none',
                                  background: 'none',
                                  padding: '0.5em 0.5em 5.5em 0.5em',
                                }}
                              >
                                <div className='driver-service-card-body-container'>
                                  {steps.map((step, index) => {
                                    // console.log('step', step)
                                    return (
                                      <TripStep
                                        key={step.id}
                                        step={step}
                                        isLast={index === steps.length - 1}
                                      />
                                    )
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                  </div>
                  {selectedTab === 1 &&
                    list.greeter &&
                    // !list.isDriverAndNotAccepted &&
                    list.status !== 'completed' &&
                    list.status !== 'cancellation_accepted_by_agent' &&
                    list.status !== 'cancelled_by_agent' &&
                    !updateDayCompleted &&
                    canSeeUpdateButton && (
                      <div className='driver-booking-cta-footer'>
                        {/* {proSteps.length > step && details && details.isDriver && ( */}
                        {proSteps.length > step && (
                          <Button
                            className='select-btn select-vehicle'
                            style={{
                              width: '100%',
                              fontWeight: '900',
                              fontSize: '16px',
                              textShadow: '0.25px 0 #ffffff',
                            }}
                            variant='brown'
                            onClick={nextStep}
                            disabled={isSubmitting}
                          >
                            {buttonLabels[step]}
                          </Button>
                        )}
                      </div>
                    )}
                  {list.status !== 'completed' &&
                  list.status !== 'cancellation_accepted_by_agent' &&
                  list.status !== 'cancelled_by_agent' &&
                  // list.dispatch &&
                  // (!list.isOperativeBranch ||
                  //   (list.dispatch.supplierId ===
                  //     list.supplierInfo.supplierId &&
                  //     list.isOperativeBranch)) &&
                  updateServiceComplete &&
                  ((isArrival &&
                    list.vipArrivalDispatchStatus !== 'completed' &&
                    list.vipArrivalDispatchStatus !== 'incomplete') ||
                    (!isArrival &&
                      list.vipDepartureDispatchStatus !== 'completed' &&
                      list.vipDepartureDispatchStatus !== 'incomplete')) ? (
                    <div className='driver-booking-cta-footer'>
                      <Button
                        className='select-btn select-vehicle'
                        style={{
                          width: '100%',
                          fontWeight: '900',
                          fontSize: '16px',
                          textShadow: '0.25px 0 #ffffff',
                        }}
                        variant='brown'
                        onClick={() => {
                          setShowCompleteBookingModal(true)
                        }}
                      >
                        Complete booking
                      </Button>
                    </div>
                  ) : (
                    <></>
                  )}
                  {selectedTab === 1 &&
                    updateDayCompleted &&
                    (!list.supplierInfo ||
                      (list.supplierInfo &&
                        list.supplierInfo.status !== 'expired')) &&
                    list.days &&
                    list.status !== 'cancellation_accepted_by_agent' &&
                    list.status !== 'cancelled_by_agent' && (
                      <div className='driver-booking-container'>
                        <div className='driver-info-layout-mobile'>
                          <div className='driver-info-column'>
                            <div className='partner-banner mt-4'>
                              <div className='imageContainer'>
                                <img
                                  src='/images/icons/icon-warning.png'
                                  alt=''
                                />
                              </div>
                              <div className='partnerContainer'>
                                <span>
                                  {list.days[currentDay]
                                    ? `Updates for Day ${currentDay} complete. Please come back on Day ${currentDay +
                                        1} (${moment
                                        .utc(list.days[currentDay].pickUpDate)
                                        .format(dateFormatDetailed)}).`
                                    : 'Updates for all days complete.'}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  {selectedTab === 0 && list.isOperativeBranch ? (
                    <>{renderLocalSupplierActions(list)}</>
                  ) : (
                    <></>
                  )}
                  {selectedTab === 0 && !list.isOperativeBranch && (
                    <>
                      {/* Standalone VIP accepts via dispatchStatus (isStandaloneAccepted),
                          not vipArrivalDispatch/vipDepartureDispatch — so the Accept/Decline
                          CTAs stayed visible after acceptance (QA 30). Hide them once accepted. */}
                      {!isStandaloneAccepted &&
                      (isArrival
                        ? !list.vipArrivalDispatch
                        : !list.vipDepartureDispatch) &&
                      list.supplierInfo &&
                      list.supplierInfo.status !== 'expired' &&
                      list.supplierInfo.status !== 'declined' &&
                      list.supplierInfo.status !== 'declined changes' &&
                      list.status !== 'completed' &&
                      list.status !== 'cancellation_accepted_by_agent' &&
                      list.status !== 'cancelled_by_agent' ? (
                        <div className='driver-booking-cta-footer'>
                          <Button
                            className='select-btn select-vehicle mb-2'
                            style={{
                              width: '100%',
                              fontWeight: '900',
                              fontSize: '16px',
                              textShadow: '0.25px 0 #ffffff',
                            }}
                            variant='brown'
                            onClick={() => {
                              onAcceptBookingVIP(list._id)
                            }}
                          >
                            Accept offer
                          </Button>
                          <Button
                            className='partner-btn-desktop-tertiary select-vehicle'
                            style={{
                              width: '100%',
                              fontWeight: '900',
                              textShadow: '0.25px 0 #a79779',
                            }}
                            onClick={() => {
                              setShowDeclineConfirmationModal(true)
                            }}
                          >
                            Decline
                          </Button>
                        </div>
                      ) : !list.partnerGreeterId &&
                        !list.greeter &&
                        list.supplierInfo &&
                        list.supplierInfo.status !== 'expired' &&
                        list.supplierInfo.status !== 'declined' &&
                        list.supplierInfo.status !== 'declined changes' ? (
                        <div className='driver-booking-cta-footer'>
                          <Button
                            className='select-btn select-vehicle'
                            style={{
                              width: '100%',
                              fontWeight: '900',
                              fontSize: '16px',
                              textShadow: '0.25px 0 #ffffff',
                            }}
                            variant='brown'
                            onClick={() => {
                              assignGreeter()
                            }}
                          >
                            {'Assign greeter'}
                          </Button>
                        </div>
                      ) : (
                        <></>
                      )}
                    </>
                  )}
                </div>
              ) : (
                <PartnerAcceptedModal
                  isBookingAccepted={showAcceptedModal}
                  isBookingDeclined={showDeclinedModal}
                  isBookingChangesAccpted={showAccptedChangesModal}
                  isBookingChangesDeclined={showDeclinedChangesModal}
                  isBookingCompleted={showCompletedModal}
                />
              )}
            </>
          </SmallDown>
        </>
      ) : (
        <LoadingSpinner />
      )}
      <ConfirmationModal
        onHide={() => {
          setShowConfirmationModal(false)
          setSubmitting(false)
        }}
        handleFunction={onConfirmationModal}
        show={showConfirmationModal}
        confirmationText={displayAlertText}
        confirmationTitle={displayAlertTitle}
        changeConfirmationTitle={true}
        driver={true}
      />
    </>
  )
}

const mapStateToProps = ({
  auth: { isLocalSupplier = null, companyId = null },
}) => ({
  isLocalSupplier,
  companyId,
})

export default withRouter(
  connect(mapStateToProps, {
    acceptOfferVIP,
    declineOffer,
    getBookingTimeZone,
    updateGreetActions,
    generatePdfBoard,
    getPrivatePartnerFileURL,
    vipBookingChangesPartner,
    updateChangesStatusPartner,
    getContinent,
    cancelDispatchBooking,
    cancelDispatchBookingMobile,
  })(BookingDetailsVIP)
)
